<template>
  <div class="createPlayStep">
    <!-- 头部返回 -->
    <div class="backBox">
      <jd-button
        type="blue"
        :styleTextObj="{
          width: '44px',
          height: '24px',
          'line-height': '24px',
          padding: '0 8px',
          'min-width': '44px',
        }"
        @click="returnBack()"
        >返回</jd-button
      >
      <span class="backBox_name">{{ activityData.name }}</span>
    </div>
    <div class="formBox">
      <div class="stepBox">
        <el-steps class="bz" :space="300" :active="localStepNum">
          <!-- <el-step title="活动模板"></el-step> -->
          <el-step title="设置规则"></el-step>
          <el-step title="完成发布"></el-step>
        </el-steps>
      </div>

      <!-- 选中活动模板 -->

      <div class="secondstep">
        <el-form
          :model="ruleForm"
          class="backgroundForm new-input-box"
          ref="ruleForm"
          label-width="155px"
        >
          <informationForm
            @selectPeopleSure="selectPeopleSure" 
            :defaultActMember.sync="actMember" 
            :defaultActivityStartTime="ruleForm.startTime" 
            :defaultActivityEndTime="ruleForm.endTime" 
            ref="informationForm" 
            v-model="ruleForm"
            :plusObject.sync="ruleDto.plusObject" 
            :openCardStartTime.sync="ruleDto.openCardStartTime" 
            :openCardEndTime.sync="ruleDto.openCardEndTime" 
            :peopleSelected.sync="peopleSelected"
            :disabled="activityData.isStart"
            :localStepNum="localStepNum" 
            :isNeedCusType="false"
            :activityId="activityData.id"
            :customerPaperwork="customerPaperwork"
            @handlCorwdTips="customerPaperwork = $event;$forceUpdate()"
          >
          </informationForm>
          <!-- <jd-title label="基本信息" type="bold"></jd-title>
          <el-form-item label="活动名称:" required>
            <el-input
              v-model="ruleForm.activityName"
              maxlength="15"
              show-word-limit
              placeholder="请输入活动名称"
              style="width: 400px"
            ></el-input>
          </el-form-item>

          <el-form-item label="活动时间:" required>
            <div class="my_select_time">
              <el-date-picker
                prefix-icon="no_icon"
                v-model="ruleForm.startTime"
                type="datetime"
                placeholder="开始日期"
                size="small"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
                style="width: 185px; font-size: 12px"
                class="time1"
                @change="activityTimeChange"
                :picker-options="pickerOptionsValue"
                :default-time="
                  this.$getDate(30)[0].substring(
                    11,
                    this.$getDate(30)[0].length
                  )
                "
                :clearable="false"
                :disabled="activityData.isStart"
              >
              </el-date-picker>
              <div class="time_to_text">至</div>
              <el-date-picker
                prefix-icon="no_icon"
                v-model="ruleForm.endTime"
                type="datetime"
                placeholder="结束日期"
                size="small"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
                style="width: 200px; font-size: 12px"
                class="time2"
                @change="activityTimeChange"
                :picker-options="pickerOptionsValueEnd"
                :default-time="
                  this.$getDate(30)[0].substring(
                    11,
                    this.$getDate(30)[0].length
                  )
                "
                :clearable="false"
                :disabled="activityData.isStart"
              >
              </el-date-picker>
              <i
                class="el-icon-circle-close date_icon1"
                v-if="!activityData.isStart"
                @click="clearTime"
              ></i>
              <img
                src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/select_date.svg"
                alt=""
                class="date_icon2"
              />
            </div>
            <span class="lastTime" style="color: #666">
              活动持续 <span style="color: #fe4d45">{{ timeDay }}</span> 天
              <span style="color: #fe4d45">{{ timeOut }}</span> 小时
              <el-tooltip
                class="item"
                effect="light"
                content="活动时间不可超过互动数据授权有效期及店铺接入有效期"
                placement="bottom"
              >
                <el-button type="text" style="width: 35px">
                  <i class="el-icon-question"></i>
                </el-button>
              </el-tooltip>
            </span>
          </el-form-item>
          <el-form-item label="活动对象:" prop="partner">
            <el-radio
              v-model="actMember"
              label="1"
              :disabled="activityData.isStart"
              >不限</el-radio
            >
            <el-radio
              v-model="actMember"
              label="2"
              :disabled="activityData.isStart"
              >会员身份</el-radio
            >
            <el-radio
              v-model="actMember"
              label="3"
              :disabled="activityData.isStart || softType == 1"
              >指定人群
              <el-button
                style="margin-left: 10px"
                v-if="actMember == '3'"
                :disabled="activityData.isStart"
                @click="openCrowd"
                >已选人群({{ peopleSelected.length }})</el-button
              >
            </el-radio>
            <div v-if="actMember == '2'" style="display: flex">
              <span>会员等级：</span>
              <el-checkbox-group
                v-model="ruleForm.partner"
                @change="checkListchange"
                :disabled="activityData.isStart"
                v-if="actMember == '2'"
              >
                <el-checkbox label="-1" name="partner">全部</el-checkbox>
                <el-checkbox
                  v-for="(item, index) in levelList"
                  :key="index"
                  :label="index + 1 + ''"
                  name="partner"
                  :disabled="ruleForm.partner == -1"
                  >{{ item }}</el-checkbox
                >
              </el-checkbox-group>
            </div>
            <div v-if="actMember == '2'" style="display: flex">
              <span>入会时间：</span>
              <el-checkbox
                v-model="ruleDto.isCheckOpenCardTime"
                :disabled="activityData.isStart"
                >指定时间段</el-checkbox
              >
              <div class="my_select_time" style="margin-left: 8px">
                <el-date-picker
                  prefix-icon="no_icon"
                  v-model="ruleDto.openCardStartTime"
                  type="datetime"
                  placeholder="开始日期"
                  size="small"
                  format="yyyy-MM-dd HH:mm:ss"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  style="width: 185px; font-size: 12px"
                  class="time1"
                  :clearable="false"
                  :disabled="
                    !ruleDto.isCheckOpenCardTime || activityData.isStart
                  "
                >
                </el-date-picker>
                <div class="time_to_text">至</div>
                <el-date-picker
                  prefix-icon="no_icon"
                  v-model="ruleDto.openCardEndTime"
                  type="datetime"
                  placeholder="结束日期"
                  size="small"
                  format="yyyy-MM-dd HH:mm:ss"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  style="width: 200px; font-size: 12px"
                  class="time2"
                  :picker-options="openCardEndTimeOptionsValue"
                  :clearable="false"
                  :disabled="
                    !ruleDto.isCheckOpenCardTime || activityData.isStart
                  "
                >
                </el-date-picker>
                <i
                  v-if="!activityData.isStart"
                  class="el-icon-circle-close date_icon1"
                  @click="clearNewTime"
                ></i>
                <img
                  src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/select_date.svg"
                  alt=""
                  class="date_icon2"
                />
              </div>
            </div>
            <span v-if="actMember == '2'" style="color: #f56c6c"
              >注意：该条件对【非会员】身份不生效</span
            >

            <span v-if="localStepNum == 3"
              >注：之前关注过店铺和未关注店铺的新粉丝可以参加活动，同一个活动只能参与一次</span
            >
          </el-form-item>

          <el-form-item label="Plus会员身份:" required>
            <el-radio
              v-model="ruleDto.plusObject"
              :label="0"
              :disabled="activityData.isStart"
              >不限</el-radio
            >
            <el-radio
              v-model="ruleDto.plusObject"
              :label="1"
              :disabled="activityData.isStart"
              >Plus会员</el-radio
            >
            <el-radio
              v-model="ruleDto.plusObject"
              :label="2"
              :disabled="activityData.isStart"
              >非plus会员</el-radio
            >
            <div style="color: #f56c6c">
              注意：使用该判断需满足“与京东PLUS团队有合作关系的商家”及“京东PLUS团队准许调用本接口的商家”，否则该条件不生效，保存活动后建议先自行测试无误后再投放。
            </div>
          </el-form-item>

          <el-form-item label="活动条件:">
            <el-checkbox
              label="关注店铺后方可参与活动"
              v-model="ruleForm.condFollow"
            ></el-checkbox>
          </el-form-item> -->

          <!-- 试用礼订单设置 -->
          <jd-title label="试用礼订单设置" type="bold"></jd-title>
          <div style="margin: 10px 0px">
            <jd-tip>满足以下下单要求，确认收货后可领取奖品</jd-tip>
          </div>
          <el-form-item label="试用礼商品下单时间:" required>
            <div>
              <div class="my_select_time">
                <el-date-picker
                  :disabled="activityData.isStart"
                  prefix-icon="no_icon"
                  v-model="ruleForm.trialRule.orderStartTime"
                  type="datetime"
                  placeholder="选择日期时间"
                  size="small"
                  format="yyyy-MM-dd HH:mm:ss"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  style="width: 185px; font-size: 12px"
                  class="time1"
                  :clearable="false"
                  :picker-options="trialOrderStartPickerOptions"
                  @change="handleTrialOrderStartTimeChange"
                >
                </el-date-picker>
                <div class="time_to_text">至</div>
                <el-date-picker
                  :disabled="activityData.isStart"
                  prefix-icon="no_icon"
                  v-model="ruleForm.trialRule.orderEndTime"
                  default-time="23:59:59"
                  type="datetime"
                  placeholder="选择日期时间"
                  size="small"
                  format="yyyy-MM-dd HH:mm:ss"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  style="width: 185px; font-size: 12px"
                  class="time2"
                  :clearable="false"
                  :picker-options="trialOrderEndPickerOptions"
                  @change="handleTrialOrderEndTimeChange"
                >
                </el-date-picker>
                <i
                  class="el-icon-circle-close date_icon1"
                  v-if="!activityData.isStart"
                  @click="cleaerLockTimeTrials"
                ></i>
                <img
                  src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/select_date.svg"
                  alt=""
                  class="date_icon2"
                />
              </div>
              <el-tooltip class="item" effect="light" placement="bottom">
                <template #content>
                  <div>1.【订单下单时间】开始时间,时间跨度最长为365天；</div>
                  <div>2.【订单下单时间】的结束时间不能晚于活动结束时间;</div>
                  <div>
                    3.如设置订单下单时间早于活动的开始时间,则可能出现用户进入活动即可领奖的情况,请谨慎设置。
                  </div>
                </template>
                <el-button type="text" style="width: 35px">
                  <i class="el-icon-question"></i>
                </el-button>
              </el-tooltip>
            </div>
          </el-form-item>
          <div class="note">
            注：试用商品的下单结束时间不得晚于活动结束时间，且需完成收货；
          </div>
          <!-- 试用复购礼 -->
          <el-form-item label="订单状态:" required>
            <el-radio-group v-model="ruleForm.trialRule.orderType" :disabled="activityData.isStart">
              <el-radio :label="0">已完成</el-radio>
              <el-radio :label="1">已付款（下单付款后即可统计（预售商品需要支付尾款才统计））</el-radio>
            </el-radio-group>
          </el-form-item>
          <div class="note">
            注：进行在指定时间内，下单并达成所选条件即可；
          </div>
          <el-form-item label="下单店铺:" required>
            <orderShopCom
              :venderIds.sync="ruleForm.trialRule.venderIds"
              :multiShopGoods.sync="trialMultiShopGoods"
              :sellerSkuList.sync="ruleForm.trialRule.sellerSkuList"
              :isDisabled="activityData.isStart"
            />
          </el-form-item>
          <el-form-item label="试用商品:" required>
            <jdTab
                :tabsList="trialNewList"
                :fatherTabAct="multiShopId"
                @tab-click="getShopList($event,1)"
            />
            <jd-button type="blue" @click="addProduct">添加商品</jd-button>
          </el-form-item>
          <div class="product-section">
            <!-- 商品列表表格 -->
            <frontPageTable :productList="trialRuleGoodsList" 
              :headerCellStyle="{'text-align': 'center','border-bottom': '2px solid #EBEEF5',background: '#FAFAFA'}" 
              :cellStyle="{ 'text-align': 'center', overflow: 'visible' }" 
              :tableStyle="'width: 920px; overflow: visible; margin-top: 15px'"
              :paginationStyle="'width: 920px; overflow: visible; margin-top: 15px;display: flex;justify-content: end;'">
              <template #tableContent>
                <el-table-column prop="productImage" label="商品图片">
                  <template slot-scope="scope">
                    <div class="product-image-cell">
                      <img v-if="scope.row.logo" :src="scope.row.logo" class="product-thumb" />
                      <div v-else class="product-placeholder">商品图片</div>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column prop="skuName" label="商品名称"></el-table-column>
                <el-table-column prop="jdPrice" label="商品价格（元）"></el-table-column>
                <el-table-column prop="skuId" label="skuId"></el-table-column>
                <el-table-column label="操作">
                  <template slot-scope="scope">
                    <jd-button type="blueText" @click="deleteProduct(scope.$index)">删除</jd-button>
                  </template>
                </el-table-column>
              </template>
            </frontPageTable>
          </div>
          <div class="note">
            所选订单商品附带赠品或商品不同仓库发货等情况，官方平台可能会进行拆单处理，请注意此类问题，确认商品与店铺已绑定，保证后续订单准确查询。
          </div>
          <div class="note" style="color: #ccc">
            <p>备注：</p>
            <p>1、试用商品里skuid不可与正装商品里skuid重合；</p>
            <p>2、选泽指定商品后，活动也将展示被添加的商品，上限展示500个；</p>
            <p>3、订单中包含该商品skuid即可参与活动。</p>
          </div>
          <el-form-item label="次数限制:" required>
            整个活动期间内，每人只限领取<span style="color: red">1</span
            >次试用礼
          </el-form-item>
          <el-form-item label="试用礼奖项列表:" required>
            <!-- 1.40新增 -->
            <el-radio-group @change="handleSetAwardsChange" v-model="ruleForm.trialRule.setAwards" :disabled="activityData.isStart">
              <el-radio :label="0">不设置奖项</el-radio>
              <el-radio :label="1">设置奖项</el-radio>
            </el-radio-group>
            <!-- 试用礼奖项列表 -->
            <div class="mtb16" v-if="ruleForm.trialRule.setAwards == 1">
                    <!-- 试用礼奖品发放形式 -->
          <el-form-item
            label="奖励发放形式:"
            required
          >
            <div style="display: flex;align-items: center;">
              <el-radio v-model="ruleForm.trialRule.sendType" :label="0" :disabled="activityData.isStart">立即发放</el-radio>
              <el-radio @change="ruleForm.trialRule.sendDay= ''" v-model="ruleForm.trialRule.sendType" :label="1" :disabled="activityData.isStart">确认收货
                <el-input
                  v-if="ruleForm.trialRule.sendType == 1"
                  v-model="ruleForm.trialRule.sendDay" :disabled="activityData.isStart" placeholder="请输入天数"
                  @input="(e) => (ruleForm.trialRule.sendDay = validSe(e))"
                  style="width: 80px;margin: 0 4px;"></el-input>
                  <el-input :disabled="true" style="width: 80px;margin: 0 4px;" v-else></el-input>
                  天后发放</el-radio>
              <el-radio @change="ruleForm.trialRule.sendDay= ''" v-model="ruleForm.trialRule.sendType" :label="2" :disabled="activityData.isStart">活动结束
                <el-input
                  v-if="ruleForm.trialRule.sendType == 2"
                  v-model="ruleForm.trialRule.sendDay" :disabled="activityData.isStart" placeholder="请输入天数"
                  @input="(e) => (ruleForm.trialRule.sendDay = validSe(e))"
                  style="width: 80px;margin: 0 4px;"></el-input>
                  <el-input :disabled="true" style="width: 80px;margin: 0 4px;" v-else></el-input>
                  天后发放</el-radio>
                                               <el-tooltip placement="top-start" effect="dark">
                <div slot="content">
                  1.立即发放:用户下单符合条件后，系统立即发放奖品;<br />
                  2.确认收货后发放:用户确认收货满XX天后，商家需自行发货;<br />
                  3.活动结束后发放:活动结束X天后，商家需自行发货;<br />
                </div>
                <div>
                  发放规则<i class="el-icon-question"></i>
                </div>
              </el-tooltip>
            </div>
          </el-form-item>
              <el-table
                :data="prizeSettingList"
                style="width: 1100px; border: 1px solid #f0f0f0"
                :header-cell-style="{
                  background: '#fafafa',
                  'text-align': 'left',
                }"
                :cell-style="{ 'text-align': 'left' }"
              >
                <el-table-column label="奖品名称" width="299">
                  <template slot-scope="scope">
                    <el-input
                      v-model="scope.row.title"
                      maxlength="12"
                      show-word-limit
                      style="width: 240px"
                    ></el-input>
                  </template>
                </el-table-column>

                <el-table-column label="奖品类型">
                  <template slot-scope="scope">
                    {{ getPrizeTypeName(scope.row.prizeType) }}
                    <!-- <span v-if="scope.row.prizeType == 1">优惠券</span>
                    <span v-if="scope.row.prizeType == 2">京豆</span>
                    <span v-if="scope.row.prizeType == 3">实物</span>
                    <span v-if="scope.row.prizeType == 4">店铺积分</span>
                    <span v-if="scope.row.prizeType == 5">京东E卡</span>
                    <span v-if="scope.row.prizeType == 6">爱奇艺会员</span>
                    <span v-if="scope.row.prizeType == 7">京东PLUS会员</span>
                    <span v-if="scope.row.prizeType == 8">现金红包</span>
                    <span v-if="scope.row.prizeType == 9">谢谢参与</span>
                    <span v-if="scope.row.prizeType == 10">礼品卡</span>
                    <span v-if="scope.row.prizeType == 12">{{ venderType ? '令牌' : '专享价' }}</span>
                    <span v-if="scope.row.prizeType == 13">令牌</span> -->
                  </template>
                </el-table-column>
                <el-table-column label="奖品价值" width="100" prop="price">
                </el-table-column>
                <el-table-column label="奖品图片" width="200">
                  <template slot-scope="scope">
                    <img
                      v-if="scope.row.logo"
                      :src="scope.row.logo"
                      style="width: 56px; height: 56px"
                    />
                  </template>
                </el-table-column>

                <el-table-column label="奖品数量" width="180">
                  <template slot-scope="scope">
                    <el-input
                      v-model.number="scope.row.totalAmount"
                      @input.native="
                        (e) =>
                          (scope.row.totalAmount = checkputn(
                            e,
                            scope.row,
                            'jindou'
                          ))
                      "
                      placeholder="请输入"
                      @input="
                        (scope.row.totalAmount = getNumberData(
                          1,
                          $event,
                          0,
                          1,
                          999999
                        )),
                          prizeNum(scope.row)
                      "
                      @blur="beAdd(scope.row)"
                      :disabled="
                        (activityData.isStart && !scope.row.minNum) ||
                        activityData.isStart
                      "
                    ></el-input>
                  </template>
                </el-table-column>
                <el-table-column label="每日发放限额" width="120">
                  <template slot-scope="scope">
                    <dailyLimitConfig
                      :row="scope.row"
                      :backgroundOpacity="backgroundOpacity"
                      :limitBtnDisabled="backgroundOpacity"
                    ></dailyLimitConfig>
                  </template>
                </el-table-column>
                <el-table-column label="操作" width="220">
                  <template slot-scope="scope">
                    <div class="flex-center">
                      <jd-button
                        type="blueText"
                        @click="centerVis(scope.row)"
                        :disabled="activityData.isStart"
                        >编辑</jd-button
                      >
                      <jd-button
                        type="blueText"
                        @click="clearPrize(scope.row, scope.$index)"
                        :disabled="activityData.isStart"
                        >清空</jd-button
                      >
                      <!-- <el-upload
                        class="label-left"
                        action="/jd-hd-web/image/upload"
                        :show-file-list="false"
                        :before-upload="beforeUpload"
                        :on-success="(res) => handleUpload(res, scope.row)"
                        :disabled="activityData.isStart"
                      >
                        <jd-button type="blueText">上传图片</jd-button>
                      </el-upload>
                      <jd-button
                        type="blueText"
                        style="margin-left: 5px"
                        v-if="activityData.isStart && scope.row.title"
                        @click="itemAddNum('prizeSettingList', scope.$index)"
                        >增加奖品数量</jd-button
                      > -->
                    </div>
                  </template>
                </el-table-column>
              </el-table>
              <div style="color: red;" v-if="activityData.isStart">修改奖品名称后，已领取的奖品记录依旧不变更名称</div>
            </div>
            <div class="tip-color" v-if="ruleForm.trialRule.setAwards==1">
              提示：用户试用装订单完成后，获得领奖资格，领取上限为1份/人；推荐配置商品券，活动效更加哦~
            </div>
          </el-form-item>
          <!-- 试用礼奖品发放形式 -->
          <!-- <el-form-item
            label="试用礼奖品发放形式:"
            required
          >
            <div style="display: flex;align-items: center;">
              <el-radio v-model="ruleForm.trialRule.sendType" :label="0" :disabled="activityData.isStart">立即发放</el-radio>
              <el-radio @change="ruleForm.trialRule.sendDay= ''" v-model="ruleForm.trialRule.sendType" :label="1" :disabled="activityData.isStart">确认收货
                <el-input
                  v-if="ruleForm.trialRule.sendType == 1"
                  v-model="ruleForm.trialRule.sendDay" :disabled="activityData.isStart" placeholder="请输入天数"
                  @input="(e) => (ruleForm.trialRule.sendDay = validSe(e))"
                  style="width: 80px;margin: 0 4px;"></el-input>
                  <el-input :disabled="true" style="width: 80px;margin: 0 4px;" v-else></el-input>
                  天后发放</el-radio>
              <el-radio @change="ruleForm.trialRule.sendDay= ''" v-model="ruleForm.trialRule.sendType" :label="2" :disabled="activityData.isStart">活动结束
                <el-input
                  v-if="ruleForm.trialRule.sendType == 2"
                  v-model="ruleForm.trialRule.sendDay" :disabled="activityData.isStart" placeholder="请输入天数"
                  @input="(e) => (ruleForm.trialRule.sendDay = validSe(e))"
                  style="width: 80px;margin: 0 4px;"></el-input>
                  <el-input :disabled="true" style="width: 80px;margin: 0 4px;" v-else></el-input>
                  天后发放</el-radio>
                                <el-tooltip placement="top-start" effect="dark">
                <div slot="content">
                  1.立即发放:用户下单符合条件后，系统立即发放奖品;<br />
                  2.确认收货后发放:用户确认收货满XX天后，商家需自行发货;<br />
                  3.活动结束后发放:活动结束X天后，商家需自行发货;<br />
                </div>
                <div>
                  发放规则<i class="el-icon-question"></i>
                </div>
              </el-tooltip>
            </div>
          </el-form-item> -->

  
          <!-- 正装礼订单设置 -->
          <jd-title label="正装礼订单设置" type="bold"></jd-title>
          <div style="margin: 10px 0px">
            <jd-tip>满足以下下单要求，确认收货后可领取奖品</jd-tip>
          </div>

          <el-form-item label="正装商品下单时间:" required>
            <div>
              <div class="my_select_time">
                <el-date-picker
                  :disabled="activityData.isStart"
                  prefix-icon="no_icon"
                  v-model="ruleForm.formalRule.orderStartTime"
                  type="datetime"
                  placeholder="选择日期时间"
                  size="small"
                  format="yyyy-MM-dd HH:mm:ss"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  style="width: 185px; font-size: 12px"
                  class="time1"
                  :clearable="false"
                  :picker-options="formalOrderStartPickerOptions"
                  @change="handleFormalOrderStartTimeChange"
                >
                </el-date-picker>
                <div class="time_to_text">至</div>
                <el-date-picker
                  :disabled="activityData.isStart"
                  prefix-icon="no_icon"
                  v-model="ruleForm.formalRule.orderEndTime"
                  default-time="23:59:59"
                  type="datetime"
                  placeholder="选择日期时间"
                  size="small"
                  format="yyyy-MM-dd HH:mm:ss"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  style="width: 185px; font-size: 12px"
                  class="time2"
                  :clearable="false"
                  :picker-options="formalOrderEndPickerOptions"
                  @change="handleFormalOrderEndTimeChange"
                >
                </el-date-picker>
                <i
                  class="el-icon-circle-close date_icon1"
                  v-if="!activityData.isStart"
                  @click="cleaerLockTimeTrial"
                ></i>
                <img
                  src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/select_date.svg"
                  alt=""
                  class="date_icon2"
                />
              </div>
              <el-tooltip class="item" effect="light" placement="bottom">
                <template #content>
                  <div>1.【订单下单时间】开始时间,时间跨度最长为365天</div>
                  <div>2.【订单下单时间】的结束时间不能晚于活动结束时间;</div>
                  <div>
                    3.如设置订单下单时间早于活动的开始时间,则可能出现用户进入活动即可领奖的情况,请谨慎设置。
                  </div>
                </template>
                <el-button type="text" style="width: 35px">
                  <i class="el-icon-question"></i>
                </el-button>
              </el-tooltip>
            </div>
          </el-form-item>
          <div class="note">
            注：正装商品下单结束时间不得晚于活动结束时间，且不可早于试用商品下单结束时间；且试用商品和正装商品的下单订单都必须完成收货。
          </div>
          <el-form-item label="订单状态:" required>
            <el-radio-group v-model="ruleForm.formalRule.orderType" :disabled="activityData.isStart">
              <el-radio :label="0">已完成</el-radio>
              <el-radio :label="1">已付款（下单付款后即可统计（预售商品需要支付尾款才统计））</el-radio>
            </el-radio-group>
          </el-form-item>
          <div class="note">
            注：下单时间不得晚于活动结束时间，不可早于试用商品下单结束时间，且需要试用和正装均满足订单状态和条件；
          </div>
          <!-- 试用复购礼 -->
          <el-form-item label="下单店铺:" required>
            <orderShopCom
              :venderIds.sync="ruleForm.formalRule.venderIds"
              :multiShopGoods.sync="multiShopGoods"
              :sellerSkuList.sync="ruleForm.formalRule.sellerSkuList"
              :isDisabled="activityData.isStart"
            />
          </el-form-item>
          <el-form-item label="正装商品:" required>
            <jdTab
                :tabsList="newList"
                :fatherTabAct="multiShopIdOne"
                @tab-click="getShopList($event,2)"
            />
            <jd-button type="blue" @click="addProductOne">添加商品</jd-button>
          </el-form-item>
          <div class="product-section">
            <!-- 商品列表表格 -->
            <frontPageTable :productList="formalRuleGoodsList"
              :headerCellStyle="{'text-align': 'center','border-bottom': '2px solid #EBEEF5',background: '#FAFAFA'}"
              :cellStyle="{ 'text-align': 'center', overflow: 'visible' }"
              :tableStyle="'width: 920px; overflow: visible; margin-top: 15px'"
              :paginationStyle="'width: 920px; overflow: visible; margin-top: 15px;display: flex;justify-content: end;'">
              <template #tableContent>
                <el-table-column prop="productImage" label="商品图片">
                  <template slot-scope="scope">
                    <div class="product-image-cell">
                      <img v-if="scope.row.logo" :src="scope.row.logo" class="product-thumb" />
                      <div v-else class="product-placeholder">商品图片</div>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column prop="skuName" label="商品名称"></el-table-column>
                <el-table-column prop="jdPrice" label="商品价格（元）"></el-table-column>
                <el-table-column prop="skuId" label="skuId"></el-table-column>
                <el-table-column label="操作">
                  <template slot-scope="scope">
                    <jd-button type="blueText" @click="deleteProductOne(scope.$index)">删除</jd-button>
                  </template>
                </el-table-column>
              </template>
            </frontPageTable>
          </div>
          <div class="note">
            所选订单商品附带赠品或商品不同仓库发货等情况，官方平台可能会进行拆单处理，请注意此类问题，确认商品与店铺已绑定，保证后续订单准确查询。
          </div>
          <div class="note" style="color: #ccc">
            <p>备注：</p>
            <p>1、试用商品里skuid不可与正装商品里skuid重合；</p>
            <p>2、选泽指定商品后，活动也将展示被添加的商品，上限展示500个；</p>
            <p>3、订单中包含该商品skuid即可参与活动。</p>
          </div>
          <el-form-item label="次数限制:" required>
            整个活动期间内，每人只限领取<span style="color: red">1</span
            >次正装礼
          </el-form-item>
          <el-form-item label="正装礼奖项列表:" required> </el-form-item>
          <!-- 正装礼奖项列表 -->
          <div class="product-section">
                   <!-- 正装礼奖品发放形式 -->
          <el-form-item
            label="奖励发放形式:"
            required
          >
            <div style="display: flex;align-items: center;">
              <el-radio v-model="ruleForm.formalRule.sendType" :label="0" :disabled="activityData.isStart">立即发放</el-radio>
              <el-radio @change="ruleForm.formalRule.sendDay= ''" v-model="ruleForm.formalRule.sendType" :label="1" :disabled="activityData.isStart">确认收货
                <el-input
                  v-if="ruleForm.formalRule.sendType == 1"
                  v-model="ruleForm.formalRule.sendDay" :disabled="activityData.isStart" placeholder="请输入天数"
                  @input="(e) => (ruleForm.formalRule.sendDay = validSe(e))"
                  style="width: 80px;margin: 0 4px;"></el-input>
                  <el-input :disabled="true" style="width: 80px;margin: 0 4px;" v-else></el-input>
                  天后发放</el-radio>
              <el-radio @change="ruleForm.formalRule.sendDay= ''" v-model="ruleForm.formalRule.sendType" :label="2" :disabled="activityData.isStart">活动结束
                <el-input
                  v-if="ruleForm.formalRule.sendType == 2"
                  v-model="ruleForm.formalRule.sendDay" :disabled="activityData.isStart" placeholder="请输入天数"
                  @input="(e) => (ruleForm.formalRule.sendDay = validSe(e))"
                  style="width: 80px;margin: 0 4px;"></el-input>
                  <el-input :disabled="true" style="width: 80px;margin: 0 4px;" v-else></el-input>
                  天后发放</el-radio>
              <el-tooltip placement="top-start" effect="dark">
                <div slot="content">
                  1.立即发放:用户下单符合条件后，系统立即发放奖品;<br />
                  2.确认收货后发放:用户确认收货满XX天后，商家需自行发货;<br />
                  3.活动结束后发放:活动结束X天后，商家需自行发货;<br />
                </div>
                <div>
                  发放规则<i class="el-icon-question"></i>
                </div>
              </el-tooltip>
            </div>
          </el-form-item>
            <el-table
              :data="prizeSettingListOne"
              style="width: 1100px; border: 1px solid #f0f0f0"
              :header-cell-style="{
                background: '#fafafa',
                'text-align': 'left',
              }"
              :cell-style="{ 'text-align': 'left' }"
            >
              <el-table-column label="奖品名称" width="299">
                <template slot-scope="scope">
                  <el-input
                    v-model="scope.row.title"
                    maxlength="12"
                    show-word-limit
                    style="width: 240px"
                  ></el-input>
                </template>
              </el-table-column>

              <el-table-column label="奖品类型">
                <template slot-scope="scope">
                  {{ getPrizeTypeName(scope.row.prizeType) }}
                  <!-- <span v-if="scope.row.prizeType == 1">优惠券</span>
                  <span v-if="scope.row.prizeType == 2">京豆</span>
                  <span v-if="scope.row.prizeType == 3">实物</span>
                  <span v-if="scope.row.prizeType == 4">店铺积分</span>
                  <span v-if="scope.row.prizeType == 5">京东E卡</span>
                  <span v-if="scope.row.prizeType == 6">爱奇艺会员</span>
                  <span v-if="scope.row.prizeType == 7">京东PLUS会员</span>
                  <span v-if="scope.row.prizeType == 8">现金红包</span>
                  <span v-if="scope.row.prizeType == 9">谢谢参与</span>
                  <span v-if="scope.row.prizeType == 10">礼品卡</span>
                  <span v-if="scope.row.prizeType == 12">{{venderType? '令牌' : '专享价'}}</span>
                  <span v-if="scope.row.prizeType == 13">令牌</span> -->
                </template>
              </el-table-column>
              <el-table-column label="奖品价值" width="100" prop="price">
              </el-table-column>
              <el-table-column label="奖品图片(238pxx238px)" width="200">
                <template slot-scope="scope">
                  <img
                    v-if="scope.row.logo"
                    :src="scope.row.logo"
                    style="width: 56px; height: 56px"
                  />
                </template>
              </el-table-column>

              <el-table-column label="奖品数量" width="180">
                <template slot-scope="scope">
                  <el-input
                    v-model.number="scope.row.totalAmount"
                    @input.native="
                      (e) =>
                        (scope.row.totalAmount = checkputn(
                          e,
                          scope.row,
                          'jindou'
                        ))
                    "
                    placeholder="请输入"
                    @input="
                      (scope.row.totalAmount = getNumberData(
                        1,
                        $event,
                        0,
                        1,
                        999999
                      )),
                        prizeNum(scope.row)
                    "
                    @blur="beAdd(scope.row)"
                    :disabled="
                      (activityData.isStart && !scope.row.minNum) ||
                      activityData.isStart
                    "
                  ></el-input>
                </template>
              </el-table-column>
              <el-table-column label="每日发放限额" width="120">
                <template slot-scope="scope">
                  <dailyLimitConfig
                    :row="scope.row"
                    :backgroundOpacity="backgroundOpacity"
                    :limitBtnDisabled="backgroundOpacity"
                  ></dailyLimitConfig>
                </template>
              </el-table-column>
              <el-table-column label="操作" width="220">
                <template slot-scope="scope">
                  <div class="flex-center">
                    <jd-button
                      type="blueText"
                      @click="centerVisOne(scope.row)"
                      :disabled="activityData.isStart"
                      >编辑</jd-button
                    >
                    <jd-button
                      type="blueText"
                      @click="clearPrizeOne(scope.row, scope.$index)"
                      :disabled="activityData.isStart"
                      >清空</jd-button
                    >
                    <!-- :disabled="activityData.isStart" -->
                    <el-upload
                      class="label-left"
                      action="/jd-hd-web/image/upload"
                      :show-file-list="false"
                      :before-upload="beforeUpload"
                      :on-success="(res) => handleUpload(res, scope.row)"
                    >
                      <jd-button :disabled="activityData.isStart" type="blueText">上传图片</jd-button>
                    </el-upload>
                    <!-- <jd-button
                      type="blueText"
                      style="margin-left: 5px"
                      v-if="activityData.isStart && scope.row.title"
                      @click="itemAddNum('prizeSettingList', scope.$index)"
                      >增加奖品数量</jd-button
                    > -->
                  </div>
                </template>
              </el-table-column>
            </el-table>
            <div style="color: red;" v-if="activityData.isStart">提示：修改奖品名称后，已领取的奖品记录依旧不变更名称</div>
          </div>

    

          <!-- <el-form-item label="兑奖时间:" required>
            <div>
              <span class="label-right">用户在</span>
              <div class="my_select_time">
                <el-date-picker
                  prefix-icon="no_icon"
                  v-model="ruleForm.prizeStartTime"
                  type="datetime"
                  placeholder="选择日期时间"
                  size="small"
                  format="yyyy-MM-dd HH:mm:ss"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  style="width: 185px; font-size: 12px"
                  class="time1"
                  :clearable="false"
                  :picker-options="prizeStartPickerOptions"
                  :disabled="activityData.isStart"
                  @change="prizeStartTimeChange"
                >
                </el-date-picker>
                <div class="time_to_text">至</div>
                <el-date-picker
                  prefix-icon="no_icon"
                  v-model="ruleForm.prizeEndTime"
                  default-time="23:59:59"
                  type="datetime"
                  placeholder="选择日期时间"
                  size="small"
                  format="yyyy-MM-dd HH:mm:ss"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  style="width: 185px; font-size: 12px"
                  class="time2"
                  :clearable="false"
                  :disabled="true"
                >
                </el-date-picker>
                <i
                  class="el-icon-circle-close date_icon1"
                  v-if="!activityData.isStart"
                  @click="cleaerPrizeTime"
                ></i>
                <img
                  src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/select_date.svg"
                  alt=""
                  class="date_icon2"
                />
              </div>
              <span class="label-left">期间内进行奖品领取</span>
            </div>
          </el-form-item> -->
          <el-form-item label="关联试用商品:" required>
            <el-radio v-model="trialProduct" :label="0"
              >符合试用礼条件可领取</el-radio
            >
            <el-radio
              v-model="trialProduct"
              :disabled="ruleForm.trialRule.setAwards == 0"
              :label="1"
              >必须领取试用礼品</el-radio
            >
            <el-tooltip
              class="item"
              effect="light"
              content="【符合试用礼条件即可】表示用户符合正装条件后，只要满足试用礼条件即可领取正装礼品，不强制要求领取试用礼品；【必须领取试用礼品】表示用户符合正装条件后，必须是已经领取试用领品才能领取正装礼品"
              placement="bottom"
            >
              <el-button type="text" style="width: 35px">
                <i class="el-icon-question m-l--50"></i>
              </el-button>
            </el-tooltip>
          </el-form-item>
          <!-- <el-form-item label="订单要求:" required>
            <div class="rule_box">
              <div class="rule_box_top">
                用户所下订单满足以下条件可以领取奖品
              </div>
              <div class="rule_box_middle">
                <el-form-item label="下单时间:" required>
                  <span class="label-right">用户在</span>
                  <div class="my_select_time">
                    <el-date-picker
                      prefix-icon="no_icon"
                      v-model="ruleForm.orderStartTime"
                      type="datetime"
                      placeholder="选择日期时间"
                      size="small"
                      format="yyyy-MM-dd HH:mm:ss"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      style="width: 185px; font-size: 12px"
                      class="time1"
                      :clearable="false"
                      :picker-options="orderStartPickerOptions"
                      :disabled="activityData.isStart"
                      @change="orderStartTimeChange"
                    >
                    </el-date-picker>
                    <div class="time_to_text">至</div>
                    <el-date-picker
                      prefix-icon="no_icon"
                      v-model="ruleForm.orderEndTime"
                      default-time="23:59:59"
                      type="datetime"
                      placeholder="选择日期时间"
                      size="small"
                      format="yyyy-MM-dd HH:mm:ss"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      style="width: 185px; font-size: 12px"
                      class="time2"
                      :clearable="false"
                      :picker-options="orderEndPickerOptions"
                      :disabled="activityData.isStart"
                      @change="orderEndTimeChange"
                    >
                    </el-date-picker>
                    <i
                      class="el-icon-circle-close date_icon1"
                      v-if="!activityData.isStart"
                      @click="clearOrderTime"
                    ></i>
                    <img
                      src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/select_date.svg"
                      alt=""
                      class="date_icon2"
                    />
                  </div>
                  <span class="label-left">期间内下单</span>
                </el-form-item>
                <el-form-item label="金额统计类型:" required>
                  <el-radio-group
                    v-model="ruleForm.orderPaymentType"
                    :disabled="activityData.isStart || venderType"
                  >
                    <el-radio :label="0"> 实付金额 </el-radio>
                    <el-radio :label="1"> 订单金额 </el-radio>
                  </el-radio-group>
                  <div style="color: red">
                    注意：由于接口原因，自营仅支持统计订单金额，pop可按需选择统计实付金额或订单金额。
                  </div>
                </el-form-item>
                <el-form-item label="商品要求:" required>
                  <el-radio-group
                    v-model="ruleForm.filterType"
                    :disabled="activityData.isStart"
                    @change="filterTypeChange"
                  >
                    <el-radio :label="0">全部</el-radio>
                    <el-radio :label="1">指定商品</el-radio>
                    <el-radio :label="2">排除商品</el-radio>
                  </el-radio-group>
                  <jd-button
                    type="default"
                    :class="[{ 'global-view-btn': backgroundOpacity }]"
                    :style="{
                      margin: ' 0 0px 0 15px',
                    }"
                    @click="exposureProducts"
                    :disabled="activityData.isStart || ruleForm.filterType == 0"
                  >
                    {{
                      selectGoodsArr.length != ""
                        ? "已选" + selectGoodsArr.length + "个"
                        : "+添加"
                    }}
                  </jd-button>
                </el-form-item>
                <el-form-item label="商品件数:" required>
                  <el-input
                    v-model="ruleForm.itemStartCount"
                    @input="
                      ruleForm.itemStartCount = getNumberData(
                        1,
                        $event,
                        0,
                        1,
                        999999
                      )
                    "
                    style="width: 140px"
                    placeholder="请输入"
                    :disabled="activityData.isStart"
                  ></el-input>
                  <span class="label-left">件及以上</span>
                </el-form-item>
                <el-form-item label="订单金额:" required>
                  <el-input
                    v-model="ruleForm.orderStartPayment"
                    @input="
                      ruleForm.orderStartPayment = ruleForm.orderStartPayment =
                        getNumberData(1, $event, 1, 0)
                    "
                    style="width: 140px"
                    placeholder="请输入"
                    :disabled="activityData.isStart"
                  ></el-input
                  ><span class="label-left">元及以上</span>
                </el-form-item>
                <el-form-item label="订单状态:" required>
                  <el-radio-group
                    :disabled="activityData.isStart"
                    v-model="ruleForm.orderStateType"
                  >
                    <el-radio :label="0">已完成</el-radio>
                    <el-radio :label="1"
                      >已付款（下单付款后即可统计（预售商品需要支付尾款才统计））</el-radio
                    >
                  </el-radio-group>
                </el-form-item>
              </div>
            </div>
          </el-form-item>
          <el-form-item label="锁权所需积分:" required>
            <el-input
              v-model="ruleForm.point"
              @input="ruleForm.point = getNumberData(1, $event, 0, 1, 999999)"
              style="width: 140px"
              placeholder="请输入"
              :disabled="activityData.isStart"
            ></el-input
            ><span class="label-left">积分</span>
          </el-form-item>
          <el-form-item label="奖品设置:" required>
            <el-table
              :data="prizeSettingList"
              style="width: 1100px; border: 1px solid #f0f0f0"
              :header-cell-style="{
                background: '#fafafa',
                'text-align': 'left',
              }"
              :cell-style="{ 'text-align': 'left' }"
            >
              <el-table-column label="奖品类型">
                <template slot-scope="scope">
                  <span v-if="scope.row.prizeType == 1">优惠券</span>
                  <span v-if="scope.row.prizeType == 2">京豆</span>
                  <span v-if="scope.row.prizeType == 3">实物</span>
                  <span v-if="scope.row.prizeType == 4">店铺积分</span>
                  <span v-if="scope.row.prizeType == 5">京东E卡</span>
                  <span v-if="scope.row.prizeType == 6">爱奇艺会员</span>
                  <span v-if="scope.row.prizeType == 7">京东PLUS会员</span>
                  <span v-if="scope.row.prizeType == 8">现金红包</span>
                  <span v-if="scope.row.prizeType == 9">谢谢参与</span>
                  <span v-if="scope.row.prizeType == 10">礼品卡</span>
                </template>
              </el-table-column>
              <el-table-column label="奖品价值" width="80" prop="price">
              </el-table-column>
              <el-table-column label="奖品图片(646px*646px)" width="200">
                <template slot-scope="scope">
                  <img
                    v-if="scope.row.logo"
                    :src="scope.row.logo"
                    style="width: 56px; height: 56px"
                  />
                </template>
              </el-table-column>

              <el-table-column label="奖品名称" width="299">
                <template slot-scope="scope">
                  <el-input
                    v-model="scope.row.title"
                    maxlength="12"
                    :disabled="
                      scope.row.prizeType != 3 ||
                      scope.row.isGoodManage ||
                      activityData.isStart
                    "
                    show-word-limit
                    style="width: 240px"
                  ></el-input>
                </template>
              </el-table-column>

              <el-table-column label="奖品数量" width="180">
                <template slot-scope="scope">
                  <el-input
                    v-model.number="scope.row.totalAmount"
                    @input.native="
                      (e) =>
                        (scope.row.totalAmount = checkputn(
                          e,
                          scope.row,
                          'jindou'
                        ))
                    "
                    placeholder="请输入"
                    @input="
                      (scope.row.totalAmount = getNumberData(
                        1,
                        $event,
                        0,
                        1,
                        999999
                      )),
                        prizeNum(scope.row)
                    "
                    @blur="beAdd(scope.row)"
                    :disabled="
                      (activityData.isStart && !scope.row.minNum) ||
                      activityData.isStart
                    "
                  ></el-input>
                </template>
              </el-table-column>

              <el-table-column label="操作" width="220">
                <template slot-scope="scope">
                  <div class="flex-center">
                    <jd-button
                      type="blueText"
                      @click="centerVis(scope.row)"
                      :disabled="activityData.isStart"
                      >选奖品</jd-button
                    >
                    <el-upload
                      class="label-left"
                      action="/jd-hd-web/image/upload"
                      :show-file-list="false"
                      :before-upload="beforeUpload"
                      :on-success="(res) => handleUpload(res, scope.row)"
                      :disabled="activityData.isStart"
                    >
                      <jd-button type="blueText">上传图片</jd-button>
                    </el-upload>
                    <jd-button
                      type="blueText"
                      style="margin-left: 5px"
                      v-if="activityData.isStart && scope.row.title"
                      @click="itemAddNum('prizeSettingList', scope.$index)"
                      >增加奖品数量</jd-button
                    >
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </el-form-item> -->

          <!--试用复购礼 - 活动监控 -->
          <jd-title label="活动监控" type="bold"></jd-title>
          <el-form-item
            label="活动强制结束:"
            class="zindexBox"
            style="z-index: 1"
          >
            <el-checkbox
              v-model="ruleForm.activityForced"
              @change="activityForcedChange"
            >
              全部奖品发完强制结束活动
            </el-checkbox>
            <div style="color: red">
              注:勾选后，所有奖品发放完后，活动会强制结束。
            </div>
          </el-form-item>

          <!-- <jd-title label="曝光商品" type="bold"></jd-title>
          <el-form-item label="曝光商品:" class="zindexBox" style="z-index: 1">
            <el-checkbox
              v-model="ruleForm.exposureSwitch"
              @change="exposureSwitchChange"
            >
              是否添加曝光商品
            </el-checkbox>
            <jd-button
              :class="[
                { add_btn1: ruleForm.exposureSwitch },
                { 'global-view-btn': backgroundOpacity },
              ]"
              style="margin: 0 15px"
              @click="exposureProductsFiter"
              :disabled="ruleForm.exposureSwitch == false"
            >
              {{
                itemListForFilter.length != ""
                  ? "添加曝光商品" +
                    "(" +
                    itemListForFilter.length +
                    "/20" +
                    ")"
                  : "添加曝光商品"
              }}
            </jd-button>
            <el-radio-group
              v-model="ruleForm.radio"
              :disabled="ruleForm.exposureSwitch == false"
            >
              <el-radio :label="0">显示京东价</el-radio>
            </el-radio-group>
            <draggable
              v-if="itemListForFilter.length > 0"
              v-model="mainImagelist"
              chosen-class="chosen"
              :scroll="true"
              animation="150"
              force-fallback="true"
              @start="isDragging = true"
              @end="onEnd"
              style="
                margin-top: 10px;
                background: rgba(38, 112, 251, 0.06);
                padding: 10px;
              "
              filter=".unmover"
            >
              <transition-group type="transition">
                <div
                  v-for="(item, index) in mainImagelist"
                  :key="item.skuId"
                  style="display: inline-block; position: relative"
                  class="show_upImg2"
                >
                  <img
                    :src="item.logo"
                    width="120px"
                    height="120px"
                    style="display: inline-block"
                  />&nbsp;
                  <div class="delectPosible">
                    <span class="delectSort">拖动排序</span>
                    <img
                      src="https://cdn-image.yucrm.cn/images/jd-front-platform/thdImg/pages/delet.svg"
                      @click.stop="delec(index)"
                      class="delectIcom"
                    />
                  </div>
                </div>
              </transition-group>
            </draggable>
          </el-form-item> -->
          <activityPageSettings isShowShopName isShowShopNameByChannel isShowMoreSet previewKey="imageUrl" :cusTemplateJSON.sync="cusTemplateJSON" :isShowExtra="true" v-model="customerPaperwork" :giftList="giftList" :templateId="templateId" @selectTemplate="selectTemplate" :widthNumber="750" :heightNumber="2148" :designSpecificationsUrl="designSpecificationsList[activityData.id]">
            <template #otherSetMiddle>
              <el-form-item label="试用订单标题:" required>
                <el-input
                  type="text"
                  style="width: 425px; margin-left: 8px"
                  show-word-limit
                  v-model="customerPaperwork.trialTitle"
                  :maxlength="10"
                  @input="$forceUpdate()"
                ></el-input>
              </el-form-item>
              <el-form-item label="正装订单标题:" required>
                <el-input
                  type="text"
                  style="width: 425px; margin-left: 8px"
                  show-word-limit
                  v-model="customerPaperwork.formalTitle"
                  :maxlength="10"
                  @input="$forceUpdate()"
                ></el-input>
              </el-form-item>
            </template>
          </activityPageSettings>
          <exposureList :defaultExposureSwitch.sync="ruleForm.exposureSwitch" v-model="itemListForFilter" :backgroundOpacity="backgroundOpacity"
            :isLimit="true"
            :limitNum="limitNum" 
            :isEdit="isCreated" 
            :multiShopSkuType.sync="multiShopSkuType" 
            :multiShopGoods="multiShopGoods" 
            :skuBelongVenderId="skuBelongVenderId"
          ></exposureList>
          <sharFrom :sharePic="sharePic" v-model="ruleForm"></sharFrom>
          <activityRules :valueRow="valueRow" :activityData="activityData" :isForceRemind.sync="isForceRemind" :isKeyActivity.sync="isKeyActivity"
            :placementPosition.sync="placementPosition" v-model="ruleForm.ruleDescription" @generateRule="generateRule"></activityRules>
          <!-- <template>
            <jd-title label="分享设置" type="bold"></jd-title>
            <div style="margin-left: 27px">
              <el-form-item label="小程序分享标题:" required label-width="125">
                <el-input
                  type="text"
                  style="width: 425px; margin-left: 8px"
                  show-word-limit
                  v-model="ruleForm.shareTitle"
                  :maxlength="28"
                  @input="$forceUpdate()"
                ></el-input>
              </el-form-item>
              <el-form-item label="小程序分享简介:" required label-width="125">
                <el-input
                  type="text"
                  style="width: 425px; margin-left: 8px"
                  show-word-limit
                  v-model="ruleForm.shareIntroduce"
                  :maxlength="28"
                  @input="$forceUpdate()"
                ></el-input>
              </el-form-item>
              <el-form-item label="小程序分享图片:" required label-width="130">
                <div class="miniAppPic" style="margin-left: 16px">
                  <div class="top">
                    <el-upload
                      class="upload"
                      action="/jd-hd-web/image/upload"
                      :show-file-list="false"
                      :before-upload="beforeUpload1"
                      :on-success="handleUpload1"
                    >
                      <jd-button type="blueText">自定义上传</jd-button>
                    </el-upload>
                    <jd-button
                      type="blueText"
                      style="margin-left: 20px"
                      @click="picUrlReset1"
                      >重置</jd-button
                    >
                  </div>
                  <div class="bottom">
                    <el-image
                      class="elImg"
                      :src="ruleForm.sharePic"
                      fit="contain"
                    >
                      <div slot="error" class="image-slot">
                        <i class="el-icon-plus"></i>
                      </div>
                    </el-image>
                    <div class="tips1">
                      <p>建议上传尺寸：200px * 200px</p>
                      <p>图片大小：1MB以内</p>
                      <p>格式：jpg、png</p>
                    </div>
                  </div>
                </div>
              </el-form-item>
            </div>
          </template> -->
          <!-- <jd-title label="活动规则" type="bold"></jd-title>
          <el-form-item label="规则内容:" required>
            <div
              style="
                width: 500px;
                backgroundcolor: rgba(250, 250, 250, 1);
                padding: 8px;
                position: relative;
              "
            >
              <el-input
                :maxlength="2000"
                type="textarea"
                class="textarea"
                style="width: 543px"
                resize="none"
                v-model="ruleForm.ruleDescription"
                show-word-limit
              >
              </el-input>
              <div style="margin-top: 16px">
                <jd-button type="blue" @click="generateRule"
                  >生成规则</jd-button
                >
              </div>
              <div class="rule-tip">
                <jd-tip color="gley">
                  提示：点击按钮自动生成规则，也可以自己编辑信息，手机端规则处显示
                </jd-tip>
              </div>
            </div>
          </el-form-item> -->

          <!-- <div
            v-if="backgroundOpacity"
            class="backgroundOpacity"
            style="height: calc(100% - 45px)"
          ></div> -->
        </el-form>
      </div>
    </div>
    <div class="create_bottom">
      <jd-button
        v-if="backgroundOpacity"
        style="margin-right: 8px"
        v-show="!itemId"
        @click="clickLocalStep()"
        >{{ backgroundOpacity ? "返回列表" : "返回上一步" }}</jd-button
      >
      <jd-button @click="saveDraft" style="margin-right: 8px" v-if="hasDraftBtn"
        >保存至草稿箱</jd-button
      >
      <template v-if="!backgroundOpacity">
        <jd-button
          v-show="!itemId"
          v-if="isSave"
          type="blue"
          @click="resetForm"
          v-preventReClick
          >保存设置</jd-button
        >
      </template>
      <jd-button v-show="itemId" style="margin-right: 8px" @click="cancelEdit"
        >取消</jd-button
      >
      <jd-button v-show="itemId" type="blue">保存设置</jd-button>
    </div>
    <!-- 选择奖品弹窗 -->
    <selectProduct
      ref="selectProduct"
      v-if="showSelectProduct"
      :echoDate="echoDate"
      :num="1"
      :actId="valueRow"
      :JingdouCount="JingdouCount"
      :typeDefault="typeDefault"
      :hideShopPoints="true"
      :isShowCoupon="true"
      :isShowJingdou="false"
      :isShowManage="false"
      :isShowEK="false"
      :isShowIQY="false"
      :isShowPLUS="false"
      :isShowHongBao="false"
      :isShowGiftCard="false"
      :isShowThing="false"
      defaultSelect="first"
      @choose-shop="getTheData"
    >
    </selectProduct>

    <!-- 正装礼奖品列表 -->
    <selectProduct
      ref="selectProductOne"
      v-if="showSelectProductOne"
      :echoDate="echoDateOne"
      :num="1"
      :actId="valueRowOne"
      :JingdouCount="JingdouCountOne"
      :typeDefault="typeDefaultOne"
      :actType="52"
      :actEndTime="ruleForm.endTime"
      @choose-shop="getTheDataOne"
    >
    </selectProduct>

    <!-- 保存并完成设置弹框 -->
    <el-dialog
      title="重要提示"
      :visible.sync="joinBlackList"
      width="800"
      @close="checked = false"
    >
      <div style="line-height: 25px; margin-bottom: 30px">
        <p>
          1、活动流量不可控，为避免因奖品发放超出预算造成损失，请检查是否填写各奖品数量限制；仔细核对当前活动内容和活动规则设置，明确活动成本预算；
        </p>
        <p>
          2、活动开始后，请不要随意变更活动规则，避免因活动规则修改导致客诉。
        </p>
      </div>

      <el-checkbox v-model="checked" label="地址" name="partner"
        >我已知晓当前活动内容设置，明确本次活动规则。</el-checkbox
      >
      <div slot="footer" class="dialog-footer">
        <jd-button @click="joinBlackList = false">取 消</jd-button>
        <jd-button
          @click="handleDialogCloseAnoth()"
          type="blue"
          style="margin-left: 8px"
          >确 定</jd-button
        >
      </div>
    </el-dialog>

    <!-- 指定购买商品 -->
    <selectGoodsMonitor
      v-if="selectGoodsState"
      ref="selectGo"
      :isShow="selectGoodsState"
      @close="selectGoodsClose"
      :selectGoods="selectGoodsArr"
      :moduleType="true"
      :skuSearch="true"
      :xianz="false"
      :disabled="backgroundOpacity"
    ></selectGoodsMonitor>

    <!-- 添加曝光商品 -->
    <selectGoodsMonitor
      v-if="selectGoodsStateFilter"
      ref="selectGoFilter"
      :isShow="selectGoodsStateFilter"
      @close="selectGoodsCloseFilter"
      :selectGoods="selectGoodsFilterArr"
      :moduleType="true"
      :skuSearch="true"
      :isLimit="true"
      :disabled="backgroundOpacity"
    ></selectGoodsMonitor>

    <!-- 试用礼订单设置-添加商品 -->
    <selectGoodsMonitor
      v-if="selectGoodsStateFilterOne"
      ref="selectGoFilterOne"
      :isShow="selectGoodsStateFilterOne"
      @close="selectGoodsCloseFilterOne"
      :selectGoods="selectGoodsFilterArrOne"
      :moduleType="true"
      :skuSearch="true"
      :isLimit="true"
      :limitNum="500"
      :venderId="multiShopId"
      :disabled="backgroundOpacity"
    ></selectGoodsMonitor>

    <!-- 正装礼-添加商品 -->
    <selectGoodsMonitor
      v-if="selectGoodsStateFilterTwo"
      ref="selectGoFilterTwo"
      :isShow="selectGoodsStateFilterTwo"
      @close="selectGoodsCloseFilterTwo"
      :selectGoods="selectGoodsFilterArrTwo"
      :moduleType="true"
      :skuSearch="true"
      :isLimit="true"
      :limitNum="500"
      :venderId="multiShopIdOne"
      :disabled="backgroundOpacity"
    ></selectGoodsMonitor>

    <!-- 选择人群弹窗 -->
    <selectPeople
      v-if="selectPeopleShow"
      :dialogVisible="selectPeopleShow"
      :peopleList="peopleList"
      @confim="selectPeopleSure"
      @close="selectPeopleShow = false"
    ></selectPeople>
    <!-- 增加奖品弹窗 -->
    <addPrizeNum
      :isShowAddNum="isShowAddNum"
      :prizeData="toAddItem"
      @confirm="confirmAdd"
      @close="isShowAddNum = false"
    />
  </div>
</template>

<script>
import selectPeople from "@/components/select-people-yunqi.vue";
import selectProduct from "./select_product_componentization.vue";
import draggable from "vuedraggable";
import selectGoodsMonitor from "@/components/selectGoodsMonitor2.vue";
import addPrizeNum from "./components/add-prize-num.vue";
import QRCode from "qrcodejs2";
import {
  pointLockSave,
  getPointLockDetail,
  hdTaskTemplateGroup,
  sellerImage,
  trialSave, //试用复购
  trialRebuyDetail, //试用复购详情
} from "@/api/jhk/trialGift.js";
import { getTaobaoItemListSku } from "@/api/jhk/analysis/ware-controller";
import { querymemberLevel } from "@/api/jhk/integralCenter/memberLevel";
import { updateCommon } from "@/api/jhk/integralCenter/integralTask";
import { publicOpen } from "@/api/jhk/public";
import frontPageTable from "./components/frontPageTable.vue"
import informationForm from "./components/informationForm.vue"
import exposureList from "./components/exposureList.vue"
import sharFrom from "./components/sharFrom.vue"
import activityRules from "./components/activityRules.vue"
import activityPageSettings from "./components/activityPageSettings.vue"
import dailyLimitConfig from "@/views/interactiveMarketing/activity/components/dailyLimitConfig.vue";
import orderShopCom from "@/views/interactiveMarketing/activity/components/multipleStoreSetting/orderShopCom.vue";
import { useValidateMultiShopGoods, useValidateMoreActSet } from "@/views/interactiveMarketing/activity/components/commDataHook/useBasicInformation.js";

const defaultTextColor = "#ffffff";

export default {
  components: {
    selectProduct,
    selectGoodsMonitor,
    draggable,
    selectPeople,
    addPrizeNum,
    informationForm,
    exposureList,
    sharFrom,
    activityRules,
    activityPageSettings,
    frontPageTable,
    dailyLimitConfig,
    orderShopCom
  },
  props: {
    itemId: "",
    stepNum: {
      type: Number,
      default: 0,
    },
    activityData: {
      type: Object,
    },
    valueRow: {
      type: Object,
      default: () => {},
    },
    isSave: {
      type: Boolean,
      default: true,
    },
    backgroundOpacity: {
      type: Boolean,
      default: false,
    },
    isDraftEdit: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    venderType() {
      // 是否为自营店铺
      return this.$store.getters.loginUserInfo.venderType;
    },
    // 判断是否有草稿箱按钮
    hasDraftBtn() {
      return this.isDraftEdit || !this.valueRow || this.activityData.isCopy;
    },
    // 1: 京获客旗舰版
    softType() {
      return this.$store.getters.loginUserInfo.yunZhouOtherType || '';
    },
    venderId() {
      // 店铺Id
      return this.$store.getters.loginUserInfo.venderId;
    },
    trialNewList() {
      return this.trialMultiShopGoods.map((item) => {
        return {
          title: item.shopTitle,
          tabKey: item.venderId,
        };
      });
    },
    newList() {
      return this.multiShopGoods.map((item) => {
        return {
          title: item.shopTitle,
          tabKey: item.venderId,
        };
      });
    },
    trialRuleGoodsList() {
      let list = []
      if(this.ruleForm.trialRule.sellerSkuList.length>0) {
       const obj = this.ruleForm.trialRule.sellerSkuList.find((item)=>item.venderId==this.multiShopId)
       if(obj) { 
         list = obj.itemList
       }
      }
      return list
    },
    formalRuleGoodsList() {
      let list = []
      if(this.ruleForm.formalRule.sellerSkuList.length>0) {
       const obj = this.ruleForm.formalRule.sellerSkuList.find((item)=>item.venderId==this.multiShopIdOne)
       if(obj) { 
         list = obj.itemList
       }
      }
      return list
    },
  },
  watch: {
    // theNum() {
    //   this.winningRate = 0;
    //   this.prizeSettingList.forEach((item) => {
    //     if (item.percentage) {
    //       this.winningRate += Number(item.percentage);
    //     }
    //   });
    //   this.winningRate = this.winningRate.toFixed(3);
    // },
    localStepNum(newVal) {
      if (newVal == 0) {
        this.$nextTick(() => {
          this.getCodeIMG();
        });
      } else {
        this.buriedPoint(1, "试用回购礼", "互动管理", "互动活动");
      }
    },
    "ruleForm.trialRule.venderIds": {
      handler(newVal, oldVal) {
        if (newVal.length < oldVal.length&&this.currentIndex==oldVal.length-1) {
          this.currentIndex--;
          this.multiShopId = newVal[this.currentIndex];
        }
      },
      deep: true,
    },
    "ruleForm.formalRule.venderIds": {
      handler(newVal, oldVal) {
        if (newVal.length < oldVal.length&&this.currentIndexOne==oldVal.length-1) {
          this.currentIndexOne--;
          this.multiShopIdOne = newVal[this.currentIndexOne];
        }
      },
      deep: true,
    }
  },
  data() {
    return {
      multiShopSkuType: 0,
      skuBelongVenderId: "",
      isCreated: false,
      limitNum: 20,
      trialMultiShopGoods: [],
      currentIndex: 0,
      currentIndexOne: 0,
      multiShopId: "",
      multiShopIdOne: "",
      multiShopGoods: [],
      cusTemplateJSON:'',
      isForceRemind:false,
      isKeyActivity: 0,
      placementPosition: [],
      shopTitle: "",
      // 表单数据
      prizeForm: {
        startTime: "",
        endTime: "",
      },

      //试用礼-商品列表
      productList: [],

      //正装礼-商品列表
      productListOne: [],

      // 奖项列表
      prizeList: [
        {
          prizeName: "满10元减1元",
          prizeType: "优惠券",
          quantity: "1张",
          totalQuantity: "输入份数",
          prizeImage: "",
        },
        {
          prizeName: "雅诗兰黛面霜30ml",
          prizeType: "实物",
          quantity: "1个",
          totalQuantity: "输入份数",
          prizeImage: "",
        },
        {
          prizeName: "店铺积分",
          prizeType: "积分",
          quantity: "100积分",
          totalQuantity: "输入份数",
          prizeImage: "",
        },
        {
          prizeName: "京豆",
          prizeType: "京豆",
          quantity: "100京豆",
          totalQuantity: "输入份数",
          prizeImage: "",
        },
      ],

      // 图片对话框相关
      imageDialogVisible: false,
      currentPrizeIndex: -1,
      currentPrizeImage: "",

      // 上传配置
      uploadUrl: "/api/upload/image", // 替换为实际的上传接口
      uploadHeaders: {
        // 添加必要的请求头，如token等
      },
      actEndTime: "",
      actMember: "1",
      selectPeopleShow: false,
      peopleList: [],
      peopleSelected: [],
      templateId: "",
      tabActive: 0,
      navItem: "",
      giftList: [],
      pageData: {
        size: 10000,
        current: 1,
        total: 0,
      },
      itemArr: [],
      itemArrOne: [],
      tempSwitchList: [
        {
          isVisible: true,
          title: "全部",
          id: -1,
        },
      ],
      echoDate: {},
      echoDateOne: {},
      includeArr: [], //指定商品
      excludeArr: [], //排除商品
      showSelectProduct: false, //试用礼
      showSelectProductOne: false, //正装礼
      // 1.14迭代 指定入会时间
      ruleDto: {
        openCardStartTime: "",
        openCardEndTime: "",
        plusObject: 0, //plus会员
      },
      openCardEndTimeOptionsValue: {
        disabledDate: (time) => {
          return (
            time.getTime() < new Date(this.ruleDto.openCardStartTime).valueOf()
          );
        },
      },
      pickerOptionsValue: {
        disabledDate: (time) => {
          if (this.ruleForm.endTime) {
            return (
              time.getTime() < Date.now() - 8.64e7 ||
              time.getTime() > new Date(this.ruleForm.endTime).valueOf()
            );
          } else {
            return time.getTime() < Date.now() - 8.64e7;
          }
        },
      },
      pickerOptionsValueEnd: {
        disabledDate: (time) => {
          if (this.ruleForm.startTime) {
            return (
              time.getTime() < Date.now() - 8.64e7 ||
              time.getTime() < new Date(this.ruleForm.startTime).valueOf()
            );
          } else {
            return time.getTime() < Date.now() - 8.64e7;
          }
        },
      },

      // 活动开始时间 =  锁权开始时间 ＜ 锁权结束时间 ≤ 兑奖开始时间＜兑奖结束时间 = 活动结束时间
      lockPickerOptions: {
        disabledDate: (time) => {
          if (this.ruleForm.lockStartTime) {
            if (this.ruleForm.prizeStartTime) {
              return (
                time.getTime() < Date.now() - 8.64e7 ||
                time.getTime() <
                  new Date(this.ruleForm.lockStartTime).valueOf() ||
                time.getTime() >
                  new Date(this.ruleForm.prizeStartTime).valueOf() ||
                (this.ruleForm.endTime &&
                  time.getTime() >
                    new Date(this.ruleForm.endTime).valueOf() -
                      72 * 60 * 60 * 1000)
              );
            } else if (this.ruleForm.prizeEndTime) {
              return (
                time.getTime() < Date.now() - 8.64e7 ||
                time.getTime() <
                  new Date(this.ruleForm.lockStartTime).valueOf() ||
                time.getTime() >
                  new Date(this.ruleForm.prizeEndTime).valueOf() ||
                (this.ruleForm.endTime &&
                  time.getTime() >
                    new Date(this.ruleForm.endTime).valueOf() -
                      72 * 60 * 60 * 1000)
              );
            } else {
              return (
                time.getTime() < Date.now() - 8.64e7 ||
                time.getTime() <
                  new Date(this.ruleForm.lockStartTime).valueOf() ||
                (this.ruleForm.endTime &&
                  time.getTime() >
                    new Date(this.ruleForm.endTime).valueOf() -
                      72 * 60 * 60 * 1000)
              );
            }
          } else if (this.ruleForm.prizeStartTime) {
            return (
              time.getTime() < Date.now() - 8.64e7 ||
              time.getTime() >
                new Date(this.ruleForm.prizeStartTime).valueOf() ||
              (this.ruleForm.endTime &&
                time.getTime() >
                  new Date(this.ruleForm.endTime).valueOf() -
                    72 * 60 * 60 * 1000)
            );
          } else {
            return (
              time.getTime() < Date.now() - 8.64e7 ||
              (this.ruleForm.endTime &&
                time.getTime() >
                  new Date(this.ruleForm.endTime).valueOf() -
                    72 * 60 * 60 * 1000)
            );
          }
        },
      },
      prizeStartPickerOptions: {
        disabledDate: (time) => {
          if (this.ruleForm.lockEndTime) {
            if (this.ruleForm.prizeEndTime) {
              return (
                time.getTime() < Date.now() - 8.64e7 ||
                time.getTime() <
                  new Date(this.ruleForm.lockEndTime).valueOf() - 8.64e7 ||
                time.getTime() > new Date(this.ruleForm.prizeEndTime).valueOf()
              );
            } else {
              return (
                time.getTime() < Date.now() - 8.64e7 ||
                time.getTime() < new Date(this.ruleForm.lockEndTime).valueOf()
              );
            }
          } else if (this.ruleForm.lockStartTime) {
            if (this.ruleForm.prizeEndTime) {
              return (
                time.getTime() < Date.now() - 8.64e7 ||
                time.getTime() <
                  new Date(this.ruleForm.lockStartTime).valueOf() ||
                time.getTime() > new Date(this.ruleForm.prizeEndTime).valueOf()
              );
            } else {
              return (
                time.getTime() < Date.now() - 8.64e7 ||
                time.getTime() < new Date(this.ruleForm.lockStartTime).valueOf()
              );
            }
          } else if (this.ruleForm.prizeEndTime) {
            return (
              time.getTime() < Date.now() - 8.64e7 ||
              time.getTime() >
                new Date(this.ruleForm.prizeEndTime).valueOf() - 8.64e7
            );
          } else {
            return time.getTime() < Date.now() - 8.64e7;
          }
        },
      },
      // 锁权开始时间≤下单开始时间＜下单结束时间≤兑奖结束时间
      orderStartPickerOptions: {
        disabledDate: (time) => {
          if (this.ruleForm.lockStartTime) {
            if (this.ruleForm.orderEndTime) {
              return (
                time.getTime() < Date.now() - 8.64e7 ||
                time.getTime() <
                  new Date(this.ruleForm.lockStartTime).valueOf() - 8.64e7 ||
                time.getTime() > new Date(this.ruleForm.orderEndTime).valueOf()
              );
            } else {
              return (
                time.getTime() < Date.now() - 8.64e7 ||
                time.getTime() <
                  new Date(this.ruleForm.lockStartTime).valueOf() - 8.64e7
              );
            }
          } else if (this.ruleForm.orderEndTime) {
            return (
              time.getTime() < Date.now() - 8.64e7 ||
              time.getTime() >
                new Date(this.ruleForm.orderEndTime).valueOf() - 8.64e7
            );
          } else {
            return time.getTime() < Date.now() - 8.64e7;
          }
        },
      },
      orderEndPickerOptions: {
        disabledDate: (time) => {
          if (this.ruleForm.orderStartTime) {
            if (this.ruleForm.prizeEndTime) {
              return (
                time.getTime() < Date.now() - 8.64e7 ||
                time.getTime() <
                  new Date(this.ruleForm.orderStartTime).valueOf() ||
                time.getTime() > new Date(this.ruleForm.prizeEndTime).valueOf()
              );
            } else {
              return (
                time.getTime() < Date.now() - 8.64e7 ||
                time.getTime() <
                  new Date(this.ruleForm.orderStartTime).valueOf()
              );
            }
          } else if (this.ruleForm.prizeEndTime) {
            return (
              time.getTime() < Date.now() - 8.64e7 ||
              time.getTime() >
                new Date(this.ruleForm.prizeEndTime).valueOf() - 8.64e7
            );
          } else {
            return time.getTime() < Date.now() - 8.64e7;
          }
        },
      },
      JingdouCount: {
        prizeCount: 0,
      },
      JingdouCountOne: {
        prizeCount: 0,
      },

      typeDefault: {
        grantType: 5, // 发放类型  传对应的id值
        display: 1, // 是否公开  传对应的id值
        type: 0, // 不禁用  传对应的id值
        noDisabled: [5], // 不禁用  传对应的id值  可不传（全部可选）
      },
      typeDefaultOne: {
        grantType: 5, // 发放类型  传对应的id值
        display: 1, // 是否公开  传对应的id值
        type: 0, // 不禁用  传对应的id值
        noDisabled: [5], // 不禁用  传对应的id值  可不传（全部可选）
      },
      qrcode: null,
      joinBlackList: false,
      checked: false,
      winningRate: 0,
      localStepNum: this.stepNum, // 将外部传入的步骤赋值到本地，避免直接更改props
      mainImagelist: [], //图片拖拽排序
      itemListForFilter: [],
      selectGoodsFilterArr: [],
      selectGoodsFilterArrOne: [],
      selectGoodsFilterArrTwo: [],
      selectGoodsStateFilter: false, //正装礼
      selectGoodsStateFilterOne: false, //试用礼
      selectGoodsStateFilterTwo: false, //试用礼
      getPrizeType: 1,

      //试用商品关联门槛
      trialProduct: 0,
      ruleForm: {
        //活动强制结束
        activityForced: false,
        //试装商品下单时间
        trialRule: {
          orderStartTime: null,
          orderEndTime: null,
          skuIds: [],
          setAwards: 0,
          orderType: 0, // 订单状态
          sendType: 0, //奖品发放形式: 0立即发放, 1确认收货后, 2活动结束后
          sendDay: "", //发放天数，当sendType为1或2时有效
          venderIds: [],
          sellerSkuList: [],
        },
        formalRule: {
          orderStartTime: null,
          orderEndTime: null,
          skuIds: [],
          doorsillType: 0,
          orderType: 0, // 订单状态
          sendType: 0, //奖品发放形式: 0立即发放, 1确认收货后, 2活动结束后
          sendDay: "", //发放天数，当sendType为1或2时有效
          venderIds: [],
          sellerSkuList: [],
        },
        terminateWhenNoPrizes: false, //活动监控
        // end
        radio: 0,
        exposureSwitch: false,
        activityName: "",
        startTime: null,
        endTime: null,
        condFollow: false,
        ruleDescription: "",
        partner: ["-1"],
        lockStartTime: null,
        lockEndTime: null,
        prizeStartTime: null,
        prizeEndTime: null,

        orderStartTime: null,
        orderEndTime: null,
        orderPaymentType: 0,
        filterType: 0,
        itemStartCount: null,
        orderStartPayment: null,
        orderStateType: 0,
        point: null,

        shareTitle: "", // 分享标题
        shareIntroduce: "", // 分享简介
        sharePic: "", // 分享图片
        firstOpenCardTimeType: 0,
        openCardBeforeDay: "",
        openCardFollow: 1,
        isValidBlackList: 0,
      },
      sharePic: "", // 初始图
      prizeSettingList: [
        //试用礼
        // 奖项设置
        {
          index: 0,
          prizeType: null,
          price: null,
          logo: null,
          title: "",
          totalAmount: null,
          taskIndex: 0,
        },
      ],
      prizeSettingListOne: [
        //正装礼
        // 奖项设置
        {
          index: 0,
          prizeType: null,
          price: null,
          logo: null,
          title: "",
          totalAmount: null,
          taskIndex: 1,
        },
      ],
      index: 0,
      indexOne: 0,
      theNum: 0,
      timeDay: 0, //活动持续天数
      timeOut: 0, //多少小时
      fileList: "",
      selectGoodsState: false, //曝光商品弹窗
      selectGoodsArr: [],
      jdCrm: {
        startTime: "",
        endTime: "",
        isCrm: false,
      },
      templateJson: {
        templateUItype: "",
      },
      levelList: [],
      isDraft: false,
      toAddItem: null,
      isShowAddNum: false,
      toAddBelong: "",
      toAddIndex: 0,
      isFirstTime: true,
      defaultLogo: "https://cdn-image.yucrm.cn/hd/images/prizeShow646.png",
      // 试用礼下单开始时间选择器配置
      trialOrderStartPickerOptions: {
        disabledDate: (time) => {
          const activityEnd = this.ruleForm.endTime
            ? new Date(this.ruleForm.endTime)
            : null;
          const orderEndTime = this.ruleForm.trialRule.orderEndTime
            ? new Date(this.ruleForm.trialRule.orderEndTime)
            : null;
          // 如果设置了活动结束时间，限制不能超过活动结束时间
          if (activityEnd) {
            const currentDate = new Date(time);
            const endDate = new Date(
              activityEnd.getFullYear(),
              activityEnd.getMonth(),
              activityEnd.getDate()
            );
            if (currentDate > endDate) {
              return true;
            }
          }
          // 如果已选择结束时间，限制跨度不超过365天
          if (orderEndTime) {
            const diffTime = Math.abs(orderEndTime - new Date(time));
            const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
            if (diffDays > 365) {
              return true;
            }
          }
        },
      },
      // 试用礼下单结束时间选择器配置
      trialOrderEndPickerOptions: {
        disabledDate: (time) => {
          const activityStart = this.ruleForm.startTime
            ? new Date(this.ruleForm.startTime)
            : null;
          const activityEnd = this.ruleForm.endTime
            ? new Date(this.ruleForm.endTime)
            : null;
          const orderStartTime = this.ruleForm.trialRule.orderStartTime
            ? new Date(this.ruleForm.trialRule.orderStartTime)
            : null;

          // 如果设置了活动开始时间，限制结束时间必须大于活动开始时间
          // if (activityStart) {
          //   const currentDate = new Date(time);
          //   const startDate = new Date(
          //     activityStart.getFullYear(),
          //     activityStart.getMonth(),
          //     activityStart.getDate()
          //   );
          //   if (currentDate <= startDate) {
          //     return true;
          //   }
          // }

          // 如果设置了活动结束时间，限制不能超过活动结束时间
          if (activityEnd) {
            const currentDate = new Date(time);
            const endDate = new Date(
              activityEnd.getFullYear(),
              activityEnd.getMonth(),
              activityEnd.getDate()
            );
            if (currentDate > endDate) {
              return true;
            }
          }

          // 如果已选择开始时间，限制跨度不超过365天，且结束时间不能早于开始时间
          if (orderStartTime) {
            if (new Date(time) < orderStartTime) {
              return true;
            }
            const diffTime = Math.abs(new Date(time) - orderStartTime);
            const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
            if (diffDays > 365) {
              return true;
            }
          }
        },
      },
      // 正装礼下单开始时间选择器配置
      formalOrderStartPickerOptions: {
        disabledDate: (time) => {
          const trialOrderStartTime = this.ruleForm.trialRule.orderStartTime
            ? new Date(this.ruleForm.trialRule.orderStartTime)
            : null;
          const activityEndTime = this.ruleForm.endTime
            ? new Date(this.ruleForm.endTime)
            : null;
          const formalOrderEndTime = this.ruleForm.formalRule.orderEndTime
            ? new Date(this.ruleForm.formalRule.orderEndTime)
            : null;
          // 正装商品下单开始时间必须大于等于试用礼下单开始时间（可以选择同一天）
          if (trialOrderStartTime) {
            const currentDate = new Date(time);
            const trialStartDate = new Date(
              trialOrderStartTime.getFullYear(),
              trialOrderStartTime.getMonth(),
              trialOrderStartTime.getDate()
            );
            if (currentDate < trialStartDate) {
              return true;
            }
          }
          // 正装商品下单开始时间必须小于等于活动结束时间（可以选择同一天）
          if (activityEndTime) {
            const currentDate = new Date(time);
            const endDate = new Date(
              activityEndTime.getFullYear(),
              activityEndTime.getMonth(),
              activityEndTime.getDate()
            );
            if (currentDate > endDate) {
              return true;
            }
          }
          // 如果已选择正装礼结束时间，限制跨度不超过385天
          if (formalOrderEndTime) {
            const diffTime = Math.abs(formalOrderEndTime - new Date(time));
            const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
            if (diffDays > 365) {
              return true;
            }
          }
        },
      },
      // 正装礼下单结束时间选择器配置
      formalOrderEndPickerOptions: {
        disabledDate: (time) => {
          const trialOrderEndTime = this.ruleForm.trialRule.orderEndTime
            ? new Date(this.ruleForm.trialRule.orderEndTime)
            : null;
          const activityStartTime = this.ruleForm.startTime
            ? new Date(this.ruleForm.startTime)
            : null;
          const activityEndTime = this.ruleForm.endTime
            ? new Date(this.ruleForm.endTime)
            : null;
          const formalOrderStartTime = this.ruleForm.formalRule.orderStartTime
            ? new Date(this.ruleForm.formalRule.orderStartTime)
            : null;
          // 正装商品下单结束时间必须大于等于试用礼下单结束时间（可以选择同一天）
          if (trialOrderEndTime) {
            const currentDate = new Date(time);
            const trialStartDate = new Date(
              trialOrderEndTime.getFullYear(),
              trialOrderEndTime.getMonth(),
              trialOrderEndTime.getDate()
            );
            if (currentDate < trialStartDate) {
              return true;
            }
          }
          // 正装商品下单结束时间必须大于活动开始时间（不能选择同一天）
          // if (activityStartTime) {
          //   const currentDate = new Date(time);
          //   const startDate = new Date(
          //     activityStartTime.getFullYear(),
          //     activityStartTime.getMonth(),
          //     activityStartTime.getDate()
          //   );
          //   if (currentDate <= startDate) {
          //     return true;
          //   }
          // }
          // 正装商品下单结束时间必须小于等于活动结束时间（可以选择同一天）
          if (activityEndTime) {
            const currentDate = new Date(time);
            const endDate = new Date(
              activityEndTime.getFullYear(),
              activityEndTime.getMonth(),
              activityEndTime.getDate()
            );
            if (currentDate > endDate) {
              return true;
            }
          }
          // 如果已选择正装礼开始时间，限制跨度不超过100天，且结束时间不能早于开始时间
          if (formalOrderStartTime) {
            if (new Date(time) < formalOrderStartTime) {
              return true;
            }
            const diffTime = Math.abs(new Date(time) - formalOrderStartTime);
            const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
            if (diffDays > 365) {
              return true;
            }
          }
        },
      },
      customerPaperwork:{
        title:'试用回购礼',
        desc:'回购正装领好礼',
        titleColor:'#1a1a1a',
        firstTitle: "下单试用装，领试用奖励",
        secondTitle: "回购正装，加赠回购好礼",
        formalTitle: "正装商品下单",
        trialTitle: "试用商品下单",
      },
    };
  },
  created() {
    console.log("当前玩法id", this.activityData.id);
    if (this.venderType) {
      this.ruleForm.orderPaymentType = 1;
    }
    this.shopTitle = this.$store.getters.loginUserInfo.shopTitle
    this.sharePic = this.getDefaultSharePic(this.activityData.id);
    this.ruleForm.sharePic = this.sharePic;
    this.ruleForm.shareTitle = `我分享了一个${this.activityData.name}活动给你，快来看看吧！`;
    this.ruleForm.shareIntroduce = `我在京东有新发现，绝对适合你，速来围观～`;
  },
  mounted() {
    this.initData();
    this.getLevel();
    this.publicOpen();
    this.getDetail();
    this.hdTaskTemplateGroup();
  },

  methods: {
    getShopList(row,type) {
      if(type==1) {
        this.multiShopId = row.name;
        this.currentIndex = row.index;
      } else {
        this.multiShopIdOne = row.name;
        this.currentIndexOne = row.index;
      }
    },
    initData() {
      this.ruleForm.trialRule.venderIds = [this.venderId];
      this.ruleForm.trialRule.sellerSkuList = [
        {
          venderId: this.venderId,
          skuIds: [],
          itemList: [],
        },
      ];
      this.ruleForm.formalRule.venderIds = [this.venderId];
      this.ruleForm.formalRule.sellerSkuList = [
        {
          venderId: this.venderId,
          skuIds: [],
          itemList: [],
        },
      ];
      this.multiShopId = this.venderId;
      this.multiShopIdOne = this.venderId;
      this.multiShopGoods = useValidateMultiShopGoods(this, [this.venderId]);
      this.trialMultiShopGoods = useValidateMultiShopGoods(this, [this.venderId]);
    },
    selectTemplate(uitype, templateId){
      if (sessionStorage.getItem("venderType") == 0) {
        this.localStepNum = 1;
      } else {
        if (this.jdCrm.isCrm) {
          this.localStepNum = 1;
        } else {
          this.$message({
            type: "warning",
            message: "自营店铺需要搭配云短信CRM使用!请联系客服!",
          });
        }
      }
      if (templateId) {
        this.templateId = templateId;
      }
      this.templateJson.templateUItype = uitype + 1;
      // 新增活动-初始化活动时间
      if (!this.valueRow && this.isFirstTime) {
        this.isFirstTime = false;
        this.setTime();
        this.activityTimeChange();
      }
    },

    handleSetAwardsChange(val) {
      if(val==0) {
        this.trialProduct = 0;
        this.prizeSettingList = [
          {
            index: 0,
            prizeType: null,
            price: null,
            logo: null,
            title: "",
            totalAmount: null,
            taskIndex: 0,
          },
        ]
      }
    },
    //清空奖品
    clearPrize(row, index) {
      this.prizeSettingList = [
        // 奖项设置
        {
          index: 0,
          prizeType: null,
          price: null,
          logo: null,
          title: "",
          totalAmount: null,
          taskIndex: 0,
        },
      ];
    },

    //正装礼清空奖品
    clearPrizeOne(row, index) {
      this.prizeSettingListOne = [
        // 奖项设置
        {
          index: 0,
          prizeType: null,
          price: null,
          logo: null,
          title: "",
          totalAmount: null,
          taskIndex: 1,
        },
      ];
    },

    //试用礼-添加商品
    addProduct() {
      // 打开商品选择对话框的逻辑
      this.selectGoodsStateFilterOne = true;
      //   if (this.itemListForFilter.length == 0) {
      //     this.itemListForFilter = [];
      //     this.selectGoodsFilterArr = [];
      //   }
      this.selectGoodsFilterArrOne = this.trialRuleGoodsList;
      // this.$refs.selectGoFilterOne.handleRightCurrentChange(1);
    },

    //正装礼-添加商品
    addProductOne() {
      // 打开商品选择对话框的逻辑
      this.selectGoodsStateFilterTwo = true;
      this.selectGoodsFilterArrTwo = this.formalRuleGoodsList;
      //   if (this.itemListForFilter.length == 0) {
      //     this.itemListForFilter = [];
      //     this.selectGoodsFilterArr = [];
      //   }
      // this.$refs.selectGoFilterTwo.handleRightCurrentChange(1);
    },

    //试用礼-删除商品
    deleteProduct(index) {
      // this.productList.splice(index, 1);
      this.ruleForm.trialRule.sellerSkuList.forEach((item) => {
        if (item.venderId == this.multiShopId) {
          item.itemList.splice(index, 1);
          item.skuIds.splice(index, 1);
        }
      })
    },

    //正装礼- 删除商品
    deleteProductOne(index) {
      this.ruleForm.formalRule.sellerSkuList.forEach((item) => {
        if (item.venderId == this.multiShopIdOne) {
          item.itemList.splice(index, 1);
          item.skuIds.splice(index, 1);
        }
      })
    },

    // 编辑奖项
    editPrize(index) {
      this.$message.info(`编辑第${index + 1}个奖项`);
    },

    // 删除奖项
    deletePrize(index) {
      this.$confirm("确认清空该奖项吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          // 清空奖项数据
          this.prizeList[index] = {
            prizeName: "",
            prizeType: "",
            quantity: "",
            totalQuantity: "",
            prizeImage: "",
          };
          this.$message.success("清空成功");
        })
        .catch(() => {
          this.$message.info("已取消");
        });
    },

    // 打开图片对话框
    openImageDialog(index) {
      this.currentPrizeIndex = index;
      this.currentPrizeImage = this.prizeList[index].prizeImage || "";
      this.imageDialogVisible = true;
    },

    // 关闭图片对话框
    closeImageDialog() {
      this.imageDialogVisible = false;
      this.currentPrizeIndex = -1;
      this.currentPrizeImage = "";
    },

    // 图片上传成功回调
    handleImageSuccess(response, file) {
      if (response.code === 200) {
        this.currentPrizeImage = response.data.url; // 根据实际接口返回结构调整
        this.$message.success("图片上传成功");
      } else {
        this.$message.error("图片上传失败：" + response.message);
      }
    },

    // 图片上传前验证
    beforeImageUpload(file) {
      const isJPGOrPNG =
        file.type === "image/jpeg" || file.type === "image/png";
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPGOrPNG) {
        this.$message.error("只能上传 JPG/PNG 格式的图片!");
        return false;
      }
      if (!isLt2M) {
        this.$message.error("图片大小不能超过 2MB!");
        return false;
      }
      return true;
    },

    // 删除图片
    removeImage() {
      this.currentPrizeImage = "";
    },

    // 保存图片
    saveImage() {
      if (this.currentPrizeIndex >= 0) {
        this.prizeList[this.currentPrizeIndex].prizeImage =
          this.currentPrizeImage;
        this.$message.success("图片保存成功");
      }
      this.closeImageDialog();
    },
    filterTypeChange(val) {
      if (val == 0) {
        this.selectGoodsArr = [];
      } else if (val == 1) {
        this.selectGoodsArr = this.includeArr;
      } else if (val == 2) {
        this.selectGoodsArr = this.excludeArr;
      }
    },
    // 改变数量值
    confirmAdd(num) {
      let { toAddBelong, toAddIndex } = this;
      this[toAddBelong][toAddIndex].totalAmount = num;
      this.isShowAddNum = false;
    },
    // 获取相关数据打开弹窗
    itemAddNum(arrStr, index) {
      this.toAddItem = {
        ...this[arrStr][index],
        num: this[arrStr][index].totalAmount,
      };
      if (!this.toAddItem.title || this.toAddItem.title == "谢谢参与") {
        this.$message.error("没有奖品不能设置数量！");
        return;
      }
      this.toAddBelong = arrStr;
      this.toAddIndex = index;
      this.isShowAddNum = true;
    },
    // 1.14迭代
    clearNewTime() {
      this.ruleDto.openCardStartTime = "";
      this.ruleDto.openCardEndTime = "";
    },
    // 打开选择人群
    openCrowd() {
      this.peopleList = this.peopleSelected.map((item) => {
        return { id: item };
      });
      this.selectPeopleShow = true;
      this.actMember = "3";
    },
    // 选择人群关闭
    selectPeopleSure(val) {
      this.peopleSelected = val.map((item) => item.id);
      this.selectPeopleShow = false;
    },
    // 京东计划数量计算
    prizeNum(row) {
      // 京豆计划已在其他函数判断，这里只计算 京东E卡、plus、爱奇艺、红包
      if ([5, 6, 7, 8, 10].includes(Number(row.prizeType))) {
        if (
          Number(row.totalAmount) &&
          Number(row.totalAmount) > row.budgetRemain
        ) {
          row.totalAmount = "";
          if (row.prizeType == 5)
            this.$message.error(
              "京东E卡总份额数量不能大于该京东E卡剩余预算额！"
            );
          if (row.prizeType == 6)
            this.$message.error(
              "爱奇艺会员总份额数量不能大于该爱奇艺会员剩余预算额！"
            );
          if (row.prizeType == 7)
            this.$message.error(
              "京东PLUS会员总份额数量不能大于该京东PLUS会员剩余预算额！"
            );
          if (row.prizeType == 8)
            this.$message.error(
              "现金红包总份额数量不能大于该现金红包剩余预算额！"
            );
          if (row.prizeType == 10)
            this.$message.error("礼品卡总份额数量不能大于该礼品卡剩余预算额！");
        }
      }
    },
    exposureSwitchChange(val) {
      if (!val) {
        this.itemListForFilter = [];
        this.mainImagelist = [];
        this.selectGoodsFilterArr = [];
      }
    },
    //活动监控
    activityForcedChange(val) {
      this.ruleForm.activityForced = val;
    },
    selectGoodsCloseFilter(data) {
      if (data) {
        this.itemListForFilter = [];
        data.forEach((value, index) => {
          let fomeVaule = {};
          fomeVaule.skuId = data[index].skuId;
          fomeVaule.logo = data[index].logo;
          fomeVaule.price = data[index].jdPrice || data[index].price;
          fomeVaule.title = data[index].wareTitle || data[index].title;
          this.itemListForFilter.push(fomeVaule);
        });
        this.selectGoodsFilterArr = this.itemListForFilter;
        this.mainImagelist = this.itemListForFilter;
      }
      this.selectGoodsStateFilter = false;
    },

    //试用商品列表
    selectGoodsCloseFilterOne(data) {
      if (data) {
        // this.productList = [];
        let list = []
        data.forEach((value, index) => {
          let fomeVaule = {};
          fomeVaule.skuId = data[index].skuId;
          fomeVaule.logo = data[index].logo;
          fomeVaule.jdPrice = data[index].jdPrice || data[index].price;
          fomeVaule.skuName = data[index].wareTitle || data[index].title;
          list.push(fomeVaule);
        });
        this.ruleForm.trialRule.sellerSkuList.forEach((item, index) => {
          if (item.venderId == this.multiShopId) {
            item.itemList = list
            item.skuIds = list.map((item) => item.skuId);
          }
        })
        this.selectGoodsFilterArrOne = list
      }
      this.selectGoodsStateFilterOne = false;
      // 校验试用礼与正装礼时候存在重合商品
      this.checkSameProduct();
    },

    //正装礼商品列表
    selectGoodsCloseFilterTwo(data) {
      if (data) {
        let list = []
        data.forEach((value, index) => {
          let fomeVaule = {};
          fomeVaule.skuId = data[index].skuId;
          fomeVaule.logo = data[index].logo;
          fomeVaule.jdPrice = data[index].jdPrice || data[index].price;
          fomeVaule.skuName = data[index].wareTitle || data[index].title;
          list.push(fomeVaule);
        });
        this.ruleForm.formalRule.sellerSkuList.forEach((item, index) => {
          if (item.venderId == this.multiShopIdOne) {
            item.itemList = list
            item.skuIds = list.map((item) => item.skuId);
          }
        })
        this.selectGoodsFilterArrTwo = list
      }
      this.selectGoodsStateFilterTwo = false;
      // 校验试用礼与正装礼时候存在重合商品
      this.checkSameProduct();
    },

    exposureProductsFiter() {
      this.selectGoodsStateFilter = true;
      if (this.itemListForFilter.length == 0) {
        this.itemListForFilter = [];
        this.selectGoodsFilterArr = [];
      }
      this.$refs.selectGoFilter.handleRightCurrentChange(1);
    },
    //删除
    delec(index) {
      this.mainImagelist.splice(index, 1);
      this.itemListForFilter.splice(index, 1);
    },
    // 图片拖拽
    onEnd() {
      this.isDragging = false;
      //拖拽完成后的顺序
      const order = this.mainImagelist.map((item) => item.skuId);
      this.itemListForFilter.sort((a, b) => {
        return order.indexOf(a.skuId) - order.indexOf(b.skuId);
      });
      this.selectGoodsFilterArr = this.itemListForFilter;
    },
    // 发放天数验证
    validSe(val) {
      // 过滤非数字输入
      val = val.replace(/[^\d]/g, '');
      if (val) {
        // 限制最大值为365
        if (parseInt(val) > 365) {
          val = '365';
        }
        // 截取长度超过3的输入
        if (val.length > 3) {
          val = val.substring(0, 3);
        }
      } else {
        val = '';
      }
      // 返回过滤后的值
      return val;
    },
    // 活动进行中修改奖品数量
    beAdd(row) {
      if (this.activityData.isStart) {
        if (Number(row.totalAmount) < row.minNum && row.minNum) {
          row.totalAmount = row.minNum;
          this.$message.warning("为避免客诉，奖品数量不能小于之前哦~");
        }
      }
    },
    // 奖品logo校验
    async beforeUpload(file) {
      // 校验文件类型
      let type = file.name.substring(file.name.lastIndexOf(".")).toLowerCase();
      let sorts = [".png", ".jpg", ".jpeg"];
      const isType = sorts.includes(type);
      if (!isType) {
        this.$message.error("所选文件格式不符，请重新选择（支持jpg、png格式）");
        return Promise.reject(false);
      }
      const status = await this.imgchecked(file, 238, 238);
      if (!status) {
        return Promise.reject(false);
      }
      const isLt3M = file.size < 1024 * 1024;
      if (!isLt3M) {
        this.$message.info("上传图片大小不能超过1MB");
        return Promise.reject(false);
      }
      return true;
    },
    // 奖品logo上传成功
    handleUpload(res, row) {
      if (res.code != 1) {
        this.$message.error(res.message);
      } else {
        row.logo = res.data;
      }
    },
    //上传图片前校验   分享设置
    async beforeUpload1(file) {
      const status = await this.imgchecked(file);
      console.log(status);
      if (!status) {
        return false;
      }
      const isLt3M = file.size < 1024 * 1024;

      let type = file.name.substring(file.name.lastIndexOf(".")).toLowerCase();
      let sorts = [".png", ".jpg"];

      if (!isLt3M) {
        this.$message.info("上传图片大小不能超过 1MB");
        return false;
      }
      if (sorts.indexOf(type) < 0) {
        this.$message.info("所选文件格式不符，请重新选择");
        return false;
      }
    },
    // 上传成功  分享设置
    handleUpload1(res) {
      if (res.code != 1) {
        this.$message.error(res.message);
      } else {
        this.ruleForm.sharePic = res.data;
      }
    },
    //判断尺寸方法 默认200*200
    imgchecked(file, width = 200, height = 200) {
      let _this = this;
      return new Promise((resolve, reject) => {
        let image = new Image();
        let _URL = window.URL || window.webkitURL;
        image.onload = function () {
          const valid = image.width == width && image.height == height;
          file.isFlag = valid;
          if (valid) {
            resolve(true);
          } else {
            _this.$message.info("图片尺寸不符合要求，请重新上传");
            reject();
          }
        };
        image.src = _URL.createObjectURL(file);
      });
    },
    // 重置背景图  分享设置
    picUrlReset1() {
      this.ruleForm.sharePic = this.sharePic;
    },
    getDaysBetween(dateString1, dateString2) {
      const startDate = Date.parse(dateString1);
      const nowDate = Date.parse(new Date());
      const endDate = Date.parse(dateString2);
      if (startDate > endDate) {
        return 0;
      }
      if (startDate == endDate) {
        return 1;
      }
      let days = 0;
      if (nowDate > startDate) {
        days = (endDate - nowDate) / (1 * 24 * 60 * 60 * 1000);
      } else {
        days = (endDate - startDate) / (1 * 24 * 60 * 60 * 1000);
      }

      return Math.floor(days) == 0 ? "1天" : Math.ceil(days) + "天";
    },

    handleNav(item, index) {
      this.tabActive = index;
      this.navItem = item;
      this.getPolite();
    },

    // 模板类型
    async hdTaskTemplateGroup() {
      const { data } = await hdTaskTemplateGroup({
        hdTaskType: this.activityData.id,
      });
      this.tempSwitchList = [
        {
          id: -1,
          groupName: "全部",
          frontHide: false,
        },
        ...data,
      ];
      this.tempSwitchList.map((item) => {
        item.isVisible = true;
        item.title = item.groupName;
      });
      this.getPolite();
    },

    // 活动模板
    async getPolite() {
      let params = {
        current: this.pageData.current,
        size: this.pageData.size,
        templateGroupId: this.navItem.id == -1 ? "" : this.navItem.id,
        source: 4,
        hdTaskType: this.activityData.id,
      };
      const { data } = await sellerImage(params);
      this.giftList = data.records.map((item) => {
        return {
          ...item,
          days: item.activityStartTime
            ? this.getDaysBetween(item.activityStartTime, item.activityEndTime)
            : "",
        };
      });
      this.pageData.total = data.total * 1;
      if(!this.templateId){
        this.selectTemplate(1,this.giftList[0].id)
      }
      this.$nextTick(() => {
        this.getCodeIMG();
      });
    },

    //会员等级
    getLevel() {
      querymemberLevel()
        .then((res) => {
          res.data.forEach((item) => {
            this.levelList.push(item.customerLevelName);
          });
        })
        .catch((res) => {});
    },
    //选中改变
    checkListchange(val) {
      val.forEach((low) => {
        if (low == -1) {
          this.ruleForm.partner = ["-1"];
        }
      });
    },

    getCodeIMG() {
      const codeImg = document.querySelectorAll(".qrCodeIMG");
      for (let index = 0; index < codeImg.length; index++) {
        const elementbox = codeImg[index];
        elementbox.innerHTML = "";
      }
      let url = "https://yq-hd-rc.isvjcloud.com/templateCommon?templateImg=";
      // const codeImg = this.$refs[queryIdIMG];
      for (let index = 0; index < codeImg.length; index++) {
        const element = codeImg[index];
        new QRCode(element, {
          width: 140, // 设置宽度，单位像素
          height: 140, // 设置高度，单位像素
          // text: url, // 设置二维码内容或跳转地址
          text: `${url}${this.giftList[index].imageUrl}`,
        });
      }
    },

    //生成二维码
    qrcodeAll(val, queryId) {
      this.qrcode = new QRCode(queryId, {
        width: 140, // 设置宽度，单位像素
        height: 140, // 设置高度，单位像素
        text: val, // 设置二维码内容或跳转地址
      });
    },
    //输入框限制负数
    checkputn(e, row = {}, type = "nojingdou") {
      if (type == "nojingdou") {
        let filtered = e.target.value.replace(/^0|[^\d]/g, "");
        e.target.value = Number(filtered);
        if (e.target.value < 1) {
          e.target.value = "";
        }
      } else {
        if (
          row.quantityTotal &&
          row.price &&
          row.totalAmount &&
          row.prizeType == 2
        ) {
          let numTotal = this.$jingdouTotal({
            ...row,
            prizeCount: row.totalAmount,
          });
          if (!numTotal) {
            this.$message.warning("京豆总份额数量不能大于该京豆预算额！");
          }
          return numTotal;
        } else {
          return row.totalAmount;
        }
      }
    },
    //生成规则
    generateRule() {
      let text1 = "",
        text2 = "",
        text3 = "",
        text4 = "",
        text5 = "",
        text6 = "",
        textTrial = "",
        textFormal = "";
        const {firstText,precautions} = this.getCommonText(this.levelList,this.ruleForm,this.ruleDto,this.actMember,false)
      if(this.ruleForm.trialRule.orderStartTime) {
        textTrial += "试用商品下单时间：" + this.ruleForm.trialRule.orderStartTime +"~"+ this.ruleForm.trialRule.orderEndTime;
      }
      if(this.ruleForm.formalRule.orderStartTime) {
        textFormal += "正装商品下单时间：" + this.ruleForm.formalRule.orderStartTime +"~"+ this.ruleForm.formalRule.orderEndTime;
      }

      //试用礼
      if (this.prizeSettingList[0].totalAmount != null) {
        text5 = `试用礼：${this.prizeSettingList[0].singleAmount}张优惠劵，限量${this.prizeSettingList[0].totalAmount}`;
      }
      //正装礼
      if (this.prizeSettingListOne[0].price != null) {
        const prizeType = this.prizeSettingListOne[0].prizeType;
        var totalAmount = this.prizeSettingListOne[0].price;
        const total = this.prizeSettingListOne[0].totalAmount
        const prizeInfoMap = {
          1: { name: "优惠券", unit: "张" },
          2: { name: "京豆", unit: "" },
          3: { name: "实物", unit: "个" },
          4: { name: "店铺积分", unit: "" },
          5: { name: "京东E卡", unit: "张" },
          6: { name: "爱奇艺会员", unit: "张" },
          7: { name: "京东PLUS会员", unit: "张" },
          8: { name: "现金红包", unit: "元" },
          10: { name: "礼品卡", unit: "张" },
        };

        const prize = prizeInfoMap[prizeType];
        if (prize) {
          if (
            prize.name == "实物" ||
            prize.name == "京东E卡" ||
            prize.name == "爱奇艺会员" ||
            prize.name == "京东PLUS会员"
          ) {
            totalAmount = 1;
          }
          if (prizeType == "1") {
            // 优惠券
            totalAmount = this.prizeSettingListOne[0].singleAmount;
          }
          text6 = `正装礼：${totalAmount}${prize.unit}${prize.name}，限量${total}`;
        }
      }
      let line = "\n";
      let prizeTitle = "\n二、【活动奖品】";
      let wayTitle = "\n三、【如何参与活动】";
      let winTitle = "\n四、【如何获奖】";
      let warnTitle = "\n五、【注意事项】";
      // 根据是否设置奖项决定是否显示限制文本
      let limitText = this.ruleForm.trialRule.setAwards === 1 ? '*活动期间：试用礼每人限领1次，正装礼每人限领1次;奖品数量有限，先到先得，送完即止。' : '正装礼每人限领1次;奖品数量有限，先到先得，送完即止。';
      let limitTextOne = this.ruleForm.trialRule.setAwards === 1 ? '，活动奖品限发1份':'';
      let prizeContent = `${text5}${text5 ? line :''}${text6}${text6 ? line: ''}${limitText}${limitText ? line : ''}`
      let wayContent = `1.用户须为京东【${this.shopTitle}店铺】的会员，并在整个活动时间内未操作退出会员。${line}2.会员于试用礼下单阶段，在京东【${this.shopTitle}店铺】进行指定试用商品付款。试用商品库存有限，卖完恢复日常价，活动期间每个尝鲜礼每IP/UDID/账号限购1单且每单限购1个，且购买多件试用商品${limitTextOne}。${line}注：试用商品范围详见#试用商品下单#${line}3.会员完成试用商品下单并付款后于正装回购下单阶段（预售订单的正装回购付款时间以尾款付款时间为准），在京东【${this.shopTitle}店铺】进行指定正装产品付款。${line}注：正装商品范围详见 #正装商品下单#${line}`
      let winContent = `1.用户需在指定的确认收货时间内完成试用商品订单和回购正装订单的收货，在活动时间内回到活动页完成奖品领取，否则奖品失效；${line}2. 如实物奖品，需要在领奖同时填写并提交收货信息，如未提交后续可在活动主页【奖品-收货信息】位置填写相关信息，且须于填写收货信息截止时间前完成填写，逾期视为放弃领奖资格。${line}3.用户在活动期间不可操作退出京东【${this.shopTitle}店铺】的会员身份，若中途退出则失去获奖资格，再次入会也无法恢复资格。${line}4.如成功参与活动的用户对商品订单进行退款处理，导致实际确认收货商品不满足活动条件，视为用户不符合兑换奖品资格，商家有权取消该用户获取奖品的资格。同一用户多个订单满足活动要求，也仅可获得1份奖品。同一用户的定义详见注意事项。${line}5.由于活动奖品数量有限，系统根据用户活动期内符合要求的首笔已确认收货的试用礼订单的确认收货时间及首笔已确认收货的指定回购正装订单的确认收货时间的后一时间为准，如果最后一份奖品排序时间出现同一时间点内有多个用户满足发奖要求，则会采取系统随机的方式进行抽取。${line}`;
      let Arr1 = firstText;
      let newText = "";
      let newNum = 0;
      Arr1.forEach((item,index) => {
        if (item.length > 0) {
          if (index != 0) {
            newText = newText + newNum + "." + item + "\n";
          } else {
            newText = newText + item + "\n";
          }
          newNum = newNum + 1;
        }
      });
      let allText = ""
      allText += newText+ textTrial+'\n' +textFormal + '\n';
      allText += prizeTitle + "\n" + prizeContent;
      allText += wayTitle + "\n" + wayContent;
      allText += winTitle + "\n" + winContent;
      allText += warnTitle + "\n" + precautions
      this.ruleForm.ruleDescription = allText;
    },
    //选择奖品弹窗
    centerVis(row) {
      this.itemArr = this.prizeSettingList;
      this.index = row.index;
      this.JingdouCount.prizeCount = row.totalAmount;
      this.echoDate = row;
      this.showSelectProduct = true;
      this.$nextTick(() => {
        this.$refs.selectProduct.openDialog();
      });
    },
    //正装礼
    centerVisOne(row) {
      this.itemArrOne = this.prizeSettingListOne;
      this.index = row.index;
      this.JingdouCountOne.prizeCount = row.totalAmount;
      this.echoDateOne = row;
      this.showSelectProductOne = true;
      this.$nextTick(() => {
        this.$refs.selectProductOne.openDialog();
      });
    },
    // 返回上一步
    returnBack() {
      if (this.valueRow && this.valueRow.id) {
        this.$emit("returnBack");
        return;
      }
      this.$emit("returnBack");
    },
    // 取消编辑
    cancelEdit() {
      this.$emit("cancelEdit");
    },
    // 获取奖品
    getTheData(data, prizeType) {
      if (data.giftType) {
        this.prizeSettingList[0].giftType = Number(data.giftType);
      }
      this.prizeSettingList[0].price = Number(data.discount);

      this.prizeSettingList[0].assetsId = Number(data.couponId || data.skuId);
      this.prizeSettingList[0].logo = data.logo || this.defaultLogo;
      this.prizeSettingList[0].prizeType = prizeType;
      this.prizeSettingList[0].title = data.name;

      if (data.singleAmount) {
        this.prizeSettingList[0].singleAmount = data.singleAmount;
      }
      if (prizeType == 1) {
        this.prizeSettingList[0].couponType = data.couponType;
        this.prizeSettingList[0].singleAmount = data.numPerSending;
        this.prizeSettingList[0].prizeGoShop = data.prizeGoShop;
      }
      if (prizeType == 2) {
        this.prizeSettingList[0].quantityTotal = data.quantityTotal;
      }
      if (prizeType == 3) {
        this.prizeSettingList[0].addressFillEndTime = data.addressFillEndTime
        this.prizeSettingList[0].predictSendTime = data.predictSendTime
        this.prizeSettingList[0].isFollowActivityEndTime = data.isFollowActivityEndTime
        this.prizeSettingList[0].shouldCollectExtraData = data.shouldCollectExtraData;
        this.prizeSettingList[0].extraQuestion = data.extraQuestion;
        this.prizeSettingList[0].addressFillLimit = data.addressFillLimit
        this.prizeSettingList[0].commitAddressLimit = data.commitAddressLimit
        if (!data.isGoodManage) {
          this.prizeSettingList[0].skuId = data.skuId;
          delete this.prizeSettingList[0].isGoodManage;
        } else {
          this.prizeSettingList[0].isGoodManage = data.isGoodManage;
        }
      }
      // 金豆、E卡、爱奇艺、PLUS、红包计划需要剩余份额
      if ([2, 5, 6, 7, 8, 10].includes(Number(prizeType))) {
        this.prizeSettingList[0].budgetRemain = data.budgetRemain;
      }
      if (prizeType == 3 && data.isGoodManage) {
        this.prizeSettingList[0].budgetRemain = data.budgetRemain;
      }
      this.showSelectProduct = false;
    },
    //正装礼
    getTheDataOne(data, prizeType) {
      if (data.giftType) {
        this.prizeSettingListOne[this.indexOne].giftType = Number(
          data.giftType
        );
      }
      this.prizeSettingListOne[this.indexOne].price = Number(data.discount);
      this.prizeSettingListOne[this.indexOne].assetsId = Number(data.couponId || data.skuId);
      this.prizeSettingListOne[this.indexOne].logo =
        data.logo || this.defaultLogo;
      this.prizeSettingListOne[this.indexOne].prizeType = prizeType;
      this.prizeSettingListOne[this.indexOne].title = data.name;

      if (data.singleAmount) {
        this.prizeSettingListOne[this.indexOne].singleAmount =
          data.singleAmount;
      }
      if (prizeType == 1) {
        this.prizeSettingListOne[this.indexOne].couponType = data.couponType;
        this.prizeSettingListOne[this.indexOne].singleAmount = data.numPerSending;
      }
      if (prizeType == 2) {
        this.prizeSettingListOne[this.indexOne].quantityTotal =
          data.quantityTotal;
      }
      if (prizeType == 4) {
        this.prizeSettingListOne[
          this.indexOne
        ].title = `${data.singleAmount}店铺积分`;
      }
      if (prizeType == 3) {
        this.prizeSettingListOne[this.indexOne].addressFillEndTime = data.addressFillEndTime
        this.prizeSettingListOne[this.indexOne].predictSendTime = data.predictSendTime
        this.prizeSettingListOne[this.indexOne].isFollowActivityEndTime = data.isFollowActivityEndTime
        this.prizeSettingListOne[this.indexOne].shouldCollectExtraData = data.shouldCollectExtraData;
        this.prizeSettingListOne[this.indexOne].extraQuestion = data.extraQuestion;
        this.prizeSettingListOne[this.indexOne].addressFillLimit = data.addressFillLimit
        this.prizeSettingListOne[this.indexOne].commitAddressLimit = data.commitAddressLimit
        if (!data.isGoodManage) {
          this.prizeSettingListOne[this.indexOne].skuId = data.skuId;
          delete this.prizeSettingListOne[this.indexOne].isGoodManage;
        } else {
          this.prizeSettingListOne[this.indexOne].isGoodManage =
            data.isGoodManage;
        }
      }
      // 实物随单发
      if (prizeType == 14 || prizeType == 1) {
        this.getPhysicalShipped(this.prizeSettingListOne[
          this.indexOne
        ],prizeType,data);
      }
      // 金豆、E卡、爱奇艺、PLUS、红包计划需要剩余份额
      if ([2, 5, 6, 7, 8, 10].includes(Number(prizeType))) {
        this.prizeSettingListOne[this.indexOne].budgetRemain =
          data.budgetRemain;
      }
      if (prizeType == 3 && data.isGoodManage) {
        this.prizeSettingListOne[this.indexOne].budgetRemain =
          data.budgetRemain;
      }
      this.showSelectProductOne = false;
    },

    // 下一步
    resetForm() {
      if (!this.ruleForm.activityName) {
        this.$message.warning("请输入活动名称");
        return;
      }
      //活动时间的限制
      if (!this.ruleForm.startTime || !this.ruleForm.endTime) {
        this.$message.warning("请输入活动时间");
        return;
      }

      // 1.14迭代 这里判断 指定入会时间
      if (this.actMember == "2") {
        if (
          this.ruleForm.firstOpenCardTimeType==1 &&!this.ruleForm.openCardBeforeDay
        ) {
          this.$message.warning("请完善首次入会时间");
          return;
        }
        if (
          this.ruleForm.firstOpenCardTimeType==2 &&
          (!this.ruleDto.openCardStartTime || !this.ruleDto.openCardEndTime)
        ) {
          this.$message.warning("请完善首次入会时间");
          return;
        }
      }

      // 商品要求
      if (this.ruleForm.filterType == 1 && !this.selectGoodsArr.length) {
        this.$message.warning("请选择指定商品");
        return;
      }
      if (this.ruleForm.filterType == 2 && !this.selectGoodsArr.length) {
        this.$message.warning("请选择排除商品");
        return;
      }

      // 试用商品下单时间非空校验
      if (
        !this.ruleForm.trialRule.orderStartTime ||
        !this.ruleForm.trialRule.orderEndTime
      ) {
        this.$message.warning("请选择试用商品下单时间");
        return;
      }

      // 试用商品下单结束时间必须小于等于活动结束时间
      const activityEndTime = new Date(this.ruleForm.endTime).getTime();
      const trialOrderEndTime = new Date(
        this.ruleForm.trialRule.orderEndTime
      ).getTime();
      if (trialOrderEndTime > activityEndTime) {
        this.$message.warning("试用商品下单结束时间不可晚于活动结束时间");
        return;
      }

      if (this.ruleForm.trialRule.setAwards == 1) {
        let flage1 = false;
        let flage2 = false;
        let flage3 = false;
        this.prizeSettingList.some((item) => {
          if (!item.title) {
            flage1 = true;
          }
          if (!item.totalAmount) {
            flage2 = true;
          }
          if (!item.logo) {
            flage3 = true;
          }
        });
        if (flage1 || flage2 || flage3) {
          this.$message.warning("请完善试用礼奖项");
          return;
        }
      }

      // 正装商品下单时间非空校验
      if (
        !this.ruleForm.formalRule.orderStartTime ||
        !this.ruleForm.formalRule.orderEndTime
      ) {
        this.$message.warning("请选择正装商品下单时间");
        return;
      }

      // 正装商品下单时间校验
      const formalOrderStartTime = new Date(
        this.ruleForm.formalRule.orderStartTime
      ).getTime();
      const formalOrderEndTime = new Date(
        this.ruleForm.formalRule.orderEndTime
      ).getTime();

      // 正装商品下单开始时间必须大于等于试用礼开始时间
      const trialOrderStartTime = new Date(
        this.ruleForm.trialRule.orderStartTime
      ).getTime();
      if (formalOrderStartTime < trialOrderStartTime) {
        this.$message.warning(
          "正装商品下单开始时间不可早于试用商品的下单开始时间"
        );
        return;
      }

      // 正装商品下单结束时间必须大于等于试用礼结束时间
      if (formalOrderEndTime < trialOrderEndTime) {
        this.$message.warning(
          "正装商品下单结束时间不可早于试用商品的下单结束时间"
        );

        return;
      }

      // 正装商品下单时间必须小于等于活动结束时间
      if (
        formalOrderStartTime > activityEndTime ||
        formalOrderEndTime > activityEndTime
      ) {
        this.$message.warning("正装商品下单结束时间不能晚于活动结束时间");
        return;
      }
      // 正式商品下单标题非空校验
      if (!this.customerPaperwork.formalTitle) {
        this.$message.warning("请输入正装订单下单标题");
        return;
      }
      // 试用商品下单标题非空校验
      if (!this.customerPaperwork.trialTitle) {
        this.$message.warning("请输入试用订单下单标题");
        return;
      }

      // 新增校验提示：试用商品当前店铺的商品不可与正装商品当前店铺的商品重合
      if (this.checkSameProduct()) {
        return;
      }

      // 公活动配置校验
      if (!useValidateMoreActSet(this)) {
        return;
      }
      //请添加曝光商品！
      if (this.ruleForm.exposureSwitch) {
        if (this.itemListForFilter.length === 0) {
          this.$message.warning("请添加曝光商品！");
          return;
        }
      }

      // 小程序分享标题
      if (!this.ruleForm.shareTitle) {
        this.$message.warning("请输入小程序分享标题");
        return;
      }
      // 小程序分享简介
      if (!this.ruleForm.shareIntroduce) {
        this.$message.warning("请输入小程序分享简介");
        return;
      }
      if (!this.ruleForm.ruleDescription) {
        this.$message.warning("请输入活动规则");
        return;
      }
      if(this.placementPosition.length==0) {    
        this.$message.warning("请选择活动投放位置！");
        return
      }

      this.joinBlackList = true;
    },
    // 保存草稿
    saveDraft() {
      //活动名称的限制
      if (!this.ruleForm.activityName) {
        this.$message.warning("请输入活动名称");
        return;
      }
      if (this.isDraftEdit) {
        this.$confirm("是否保存对当前草稿的修改?", "", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          this.isDraft = true;
          this.handleDialogCloseAnoth();
        });
      } else {
        this.$confirm("是否存为草稿?", "", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          this.isDraft = true;
          this.handleDialogCloseAnoth();
        });
      }
    },
    handleDialogCloseAnoth() {
      const {
        activityName,
        startTime,
        endTime,
        condFollow,
        radio,
        partner,
        ruleDescription,
        filterType,
        point,
        shareTitle,
        shareIntroduce,
        sharePic,
        firstOpenCardTimeType,
        openCardBeforeDay,
        openCardFollow,
        studentStatus,
      } = this.ruleForm;

      const obj = {
        activityName,
        startTime,
        endTime,
        condFollow: Number(condFollow),
        ruleDTO: {},
        priceType: radio, //  0：显示京东价 1：显示促销
        ruleDescription,
        templateId: this.templateId,
        studentStatus
      };
      // 活动对象
      if (this.actMember == 1) {
        obj.allowLevel = "-1";
      } else if (this.actMember == 3) {
        obj.allowLevel = "99";
        obj.crowdIds = this.peopleSelected.join(",");
      } else if (this.actMember == 2) {
        obj.allowLevel = partner.join(",");
        if (obj.allowLevel == "-1") {
          //会员等级设置
          let list = ["-1"];
          this.levelList.forEach((item, index) => {
            let num = index + 1;
            list.push(num);
          });
          obj.allowLevel = list.join(",");
        }
        // 入会时间
        obj.ruleDTO.firstOpenCardTimeType = firstOpenCardTimeType;
        // obj.ruleDTO.openCardFollow = openCardFollow;
        if(firstOpenCardTimeType==2) {
          obj.ruleDTO.openCardStartTime = this.ruleDto.openCardStartTime;
          obj.ruleDTO.openCardEndTime = this.ruleDto.openCardEndTime;
        } else if(firstOpenCardTimeType==1) {
          obj.ruleDTO.openCardBeforeDay = openCardBeforeDay;
        }

      }
      obj.ruleDTO.openCardFollow = openCardFollow;
      // plus会员
      obj.ruleDTO.plusObject = this.ruleDto.plusObject;
      obj.ruleDTO.cusTemplateJSON = this.cusTemplateJSON
      obj.ruleDTO.isForceRemind = this.isForceRemind
      obj.isKeyActivity = this.isKeyActivity;
      obj.placementPosition = this.placementPosition.join(",");

      //试用复购-试用礼订单设置
      obj.ruleDTO.trialRule = this.ruleForm.trialRule;
      obj.ruleDTO.formalRule = this.ruleForm.formalRule;
      //试用复购-试用商品列表
      // obj.ruleDTO.trialRule.skuIds = this.productList.map((val) => {
      //   return val.skuId;
      // });
      obj.ruleDTO.trialRule.skuIds = []
      obj.ruleDTO.trialRule.sellerSkuList = this.ruleForm.trialRule.sellerSkuList
      //试用正装礼-试用商品列表
      // obj.ruleDTO.formalRule.skuIds = this.productListOne.map((val) => {
      //   return val.skuId;
      // });
      obj.ruleDTO.formalRule.skuIds = []
      obj.ruleDTO.formalRule.sellerSkuList = this.ruleForm.formalRule.sellerSkuList

      //试用关联门槛
      obj.ruleDTO.formalRule.doorsillType = this.trialProduct;

      //活动强制结束
      obj.ruleDTO.terminateWhenNoPrizes = this.ruleForm.activityForced;

      //试用复购-正装礼订单设置
      obj.ruleDTO.formalRule = this.ruleForm.formalRule;

      //商品要求
      obj.ruleDTO.filterType = filterType;
      if (filterType == 1) {
        obj.ruleDTO.itemList = this.includeArr;
        obj.ruleDTO.skuIdList = this.includeArr.map((item) => item.skuId);
      } else if (filterType == 2) {
        obj.ruleDTO.itemList = this.excludeArr;
        obj.ruleDTO.skuIdList = this.excludeArr.map((item) => item.skuId);
      }

      // 奖品设置
      const hasPrize = this.prizeSettingList.every((item) => item.prizeType);
      const hasPrize1 = this.prizeSettingListOne.every(
        (item) => item.prizeType
      );

      // if (hasPrize) {
      //   obj.pointActivityPrizeDTOList = this.prizeSettingList;
      // } else {
      //   obj.pointActivityPrizeDTOList = [];
      // }

      // if (hasPrize1) {
      //   obj.pointActivityPrizeDTOList = this.prizeSettingListOne;
      // } else {
      //   obj.pointActivityPrizeDTOList = [];
      // }

      // if(hasPrize && hasPrize1){
      //   obj.pointActivityPrizeDTOList = this.prizeSettingList.concat(this.prizeSettingListOne);
      // }else{
      //   obj.pointActivityPrizeDTOList = [];
      // }

      if (hasPrize && hasPrize1) {
        obj.pointActivityPrizeDTOList = this.prizeSettingList.concat(
          this.prizeSettingListOne
        );
      } else if (hasPrize) {
        obj.pointActivityPrizeDTOList = this.prizeSettingList;
      } else if (hasPrize1) {
        obj.pointActivityPrizeDTOList = this.prizeSettingListOne;
      } else {
        obj.pointActivityPrizeDTOList = [];
      }
      // 统一处理提交地址限制：数组转逗号分隔字符串
      obj.pointActivityPrizeDTOList = obj.pointActivityPrizeDTOList.map((item) => {
        if (item.prizeType == 3 && Array.isArray(item.commitAddressLimit)) {
          item.commitAddressLimit = item.commitAddressLimit.join(',');
        }
        return item;
      });

      // 锁权所需积分
      obj.ruleDTO.point = point;

      // 活动页设置
      obj.ruleDTO.customerPaperwork = JSON.stringify(this.customerPaperwork)

      // 曝光商品
      obj.isExposureItem = this.ruleForm.exposureSwitch ? 1 : 0; //是否添加曝光商品 0 否 1 是
      if (obj.isExposureItem) {
        obj.itemList = this.itemListForFilter;
      }
      obj.ruleDTO.multiShopSkuType = this.multiShopSkuType;
      obj.ruleDTO.skuBelongVenderId =  this.multiShopSkuType==0 && this.itemListForFilter.length>0 ? this.itemListForFilter[0].belongVenderId : ""

      // 分享设置
      obj.ruleDTO.shareTitle = shareTitle;
      obj.ruleDTO.shareIntroduce = shareIntroduce;
      obj.ruleDTO.sharePic = sharePic;
      // 奖品发放形式
      obj.ruleDTO.sendType = this.ruleDto.sendType;
      obj.ruleDTO.sendDay = this.ruleDto.sendDay;

      if (this.checked == true || this.isDraft) {
        if (this.activityData.isStart) {
          let params = {
            activityId: this.valueRow.id,
            ruleDescription: obj.ruleDescription,
            prizes: (this.ruleForm.trialRule.setAwards ==1||(this.prizeSettingListOne.length>0&&this.prizeSettingListOne.some((item)=>item.prizeType))) ? obj.pointActivityPrizeDTOList.map((item) => {
              return {
                ...item,
                prizeId: item.id,
                title: item.title,
              };
            }) : [],
            isExposureItem: this.ruleForm.exposureSwitch ? 1 : 0,
            itemList: this.itemListForFilter,
            activityName: obj.activityName,
            condFollow: obj.condFollow,
            ruleDto: obj.ruleDTO,
            endTime: obj.endTime,
            templateId: this.templateId,
            isValidBlackList: this.ruleForm.isValidBlackList,
          };
          updateCommon(params)
            .then((res) => {
              if (res && res.code == 1) {
                this.joinBlackList = false;
                this.$router.push({
                  name: "throw",
                  query: {
                    id: res.data.id,
                    activityType: res.data.activityType,
                  },
                });
                this.$message.success(res.message);
              } else {
                this.$message.error(res.message);
              }
            })
            .catch((res) => {});
        } else {
          if (this.isDraft) {
            obj.status = 5;
          } else {
            // 保存正式活动不需要status
            if (obj.status) {
              delete obj.status;
            }
            if (!this.activityData.isCopy && !this.isDraftEdit) {
              // 未开始活动修改
              if (this.valueRow && this.valueRow.id) {
                obj.activityId = this.valueRow.id;
              }
            }
          }
          // 草稿箱编辑-添加活动id
          if (this.isDraftEdit) {
            obj.id = this.valueRow.id;
          }
          trialSave(obj)
            .then((res) => {
              if (res && res.code == 1) {
                if (this.isDraft) {
                  this.$message.success("保存成功！");
                  this.$emit("returnBack", true);
                } else {
                  this.joinBlackList = false;
                  this.$router.push({
                    name: "throw",
                    query: {
                      id: res.data.id,
                      activityType: res.data.activityType,
                    },
                  });
                  this.$message.success(res.message);
                }
              } else {
                this.$message.error(res.message);
              }
            })
            .catch((res) => {});
        }
      } else {
        this.$message.info("请勾选明确活动规则后即可创建");
        return;
      }
    },
    //获取活动详情
    getDetail() {
      if (this.valueRow && this.valueRow.id) {
        trialRebuyDetail(this.valueRow.id)
          .then((res) => {
            try {
              const {
                activityName,
                startTime,
                endTime,
                allowLevel,
                condFollow,
                ruleDescription,
                ruleDto,
                pointActivityPrizeDTOList,
                isExposureItem,
                isKeyActivity,
                placementPosition,
                studentSatus,
              } = res.data;
              const {
                orderStartTime,
                orderEndTime,
                filterType,
                itemList,
                itemStartCount,
                orderStartPayment,
                orderStateType,
                firstOpenCardTimeType,
                openCardStartTime,
                openCardEndTime,
                plusObject,
                shareTitle,
                shareIntroduce,
                sharePic,
                openCardBeforeDay,
                openCardFollow,
                multiShopSkuType,
                skuBelongVenderId,
              } = ruleDto;
              if(ruleDto.isForceRemind ){
                this.isForceRemind = ruleDto.isForceRemind 
              }
              this.isKeyActivity = isKeyActivity||0;
              this.placementPosition = placementPosition ? placementPosition.split(",") : ["SHOP"];
              // 学生身份
              this.ruleForm.studentSatus = studentSatus || "";
              if(ruleDto.cusTemplateJSON){
                this.cusTemplateJSON = ruleDto.cusTemplateJSON 
              }
              this.templateId = res.data.templateId
              // 活动名称
              this.ruleForm.activityName =
                activityName + (this.activityData.isCopy ? "复制" : "");
              // 记录活动结束时间
              this.actEndTime = endTime;
              // 活动对象
              if (allowLevel == "99") {
                this.peopleSelected = res.data.crowdIds.split(",");
                this.actMember = "3";
              } else if (allowLevel == "-1") {
                this.actMember = "1";
              } else {
                this.actMember = "2";
                if (allowLevel.indexOf("-1") != -1) {
                  this.ruleForm.partner = ["-1"];
                } else {
                  this.ruleForm.partner = allowLevel.split(",");
                }
              }
              // 关注
              this.ruleForm.condFollow = Boolean(condFollow);
              this.ruleForm.isValidBlackList = res.data.isValidBlackList;
              this.ruleForm.openCardFollow = openCardFollow || 1
              // 入会时间
              this.ruleForm.firstOpenCardTimeType = firstOpenCardTimeType;

              // 回显兼容旧活动
              if(openCardStartTime&&openCardEndTime){
                this.ruleDto.openCardStartTime = openCardStartTime;
                this.ruleDto.openCardEndTime = openCardEndTime;
                this.ruleForm.firstOpenCardTimeType = 2;
              }
              if(firstOpenCardTimeType==1) {
                this.ruleForm.openCardBeforeDay = openCardBeforeDay;
              }

              // plus会员
              this.ruleDto.plusObject = plusObject;

              // 下单时间
              this.ruleForm.orderStartTime = orderStartTime;
              this.ruleForm.orderEndTime = orderEndTime;

              //商品要求
              this.ruleForm.filterType = filterType;
              if (filterType == 1) {
                this.includeArr = itemList;
              } else if (filterType == 2) {
                this.excludeArr = itemList;
              }
              this.filterTypeChange(filterType);
              //商品件数
              this.ruleForm.itemStartCount = itemStartCount;
              // 订单金额
              this.ruleForm.orderStartPayment = orderStartPayment;
              // 订单状态
              this.ruleForm.orderStateType = orderStateType;
              //试用礼回购时间
              this.ruleForm.trialRule = ruleDto.trialRule;
              this.ruleForm.formalRule = ruleDto.formalRule;
              this.$set(this.ruleForm.formalRule,"orderType",ruleDto.formalRule.orderType || 0)
              this.$set(this.ruleForm.trialRule,"orderType",ruleDto.trialRule.orderType || 0)
              if(ruleDto.formalRule.venderIds&&ruleDto.formalRule.venderIds.length>0){
                this.ruleForm.formalRule.venderIds = ruleDto.formalRule.venderIds;
              } else {
                this.ruleForm.formalRule.venderIds = [this.venderId];
              }
              if(ruleDto.trialRule.venderIds&&ruleDto.trialRule.venderIds.length>0){
                this.ruleForm.trialRule.venderIds = ruleDto.trialRule.venderIds;
              } else  {
                this.ruleForm.trialRule.venderIds = [this.venderId];
              }
              if(ruleDto.formalRule.sellerSkuList&&ruleDto.formalRule.sellerSkuList.length>0){
                this.ruleForm.formalRule.sellerSkuList = ruleDto.formalRule.sellerSkuList;
              } else {
                this.ruleForm.formalRule.sellerSkuList = [{
                  skuIds: ruleDto.formalRule.skuIds,
                  venderId: this.venderId,
                  itemList: []
                }];
              }
              if(ruleDto.trialRule.sellerSkuList&&ruleDto.trialRule.sellerSkuList.length>0){
                this.ruleForm.trialRule.sellerSkuList = ruleDto.trialRule.sellerSkuList;
              } else {
                this.ruleForm.trialRule.sellerSkuList = [{
                  skuIds: ruleDto.trialRule.skuIds,
                  venderId: this.venderId,
                  itemList: []
                }];
              }
              if (this.activityData.isCopy||this.isDraftEdit) {
                // 跨店复制
                if(this.ruleForm.trialRule.venderIds.length>0) {
                  let index = this.ruleForm.trialRule.venderIds.findIndex((item)=>{
                    return item == this.venderId
                  })
                  if(index==-1) {
                    this.ruleForm.trialRule.venderIds.unshift(Number(this.venderId))
                    this.ruleForm.trialRule.sellerSkuList.unshift({
                      venderId: Number(this.venderId),
                      skuIds: [],
                      itemList: [],
                    })
                  }
                }
                if(this.ruleForm.formalRule.venderIds.length>0) {
                  let index = this.ruleForm.formalRule.venderIds.findIndex((item)=>{
                    return item == this.venderId
                  })
                  if(index==-1) {
                    this.ruleForm.formalRule.venderIds.unshift(Number(this.venderId))
                    this.ruleForm.formalRule.sellerSkuList.unshift({
                      venderId: Number(this.venderId),
                      skuIds: [],
                      itemList: [],
                    })
                  }
                }
              }
              this.trialProduct = ruleDto.formalRule.doorsillType; //关联门槛
              this.ruleForm.activityForced = ruleDto.terminateWhenNoPrizes; //活动强制结束
              this.trialMultiShopGoods = this.ruleForm.trialRule.venderIds&&this.ruleForm.trialRule.venderIds.length? useValidateMultiShopGoods(this, this.ruleForm.trialRule.venderIds):[this.venderId];
              this.multiShopGoods = this.ruleForm.formalRule.venderIds&&this.ruleForm.formalRule.venderIds.length? useValidateMultiShopGoods(this, this.ruleForm.formalRule.venderIds):[this.venderId];
              //试用商品和正装商品
              let formalRuleReqList = []
              let trialRuleReqList = []
              this.ruleForm.formalRule.sellerSkuList.forEach(item => {
                this.$set(item,"itemList",[])
                formalRuleReqList.push(
                  getTaobaoItemListSku({
                    current: 1,
                    size: item.skuIds.length,
                    skuIds: item.skuIds,
                    venderId: item.venderId,
                  }),
                )
              })
              this.ruleForm.trialRule.sellerSkuList.forEach(item => {
                this.$set(item,"itemList",[])
                trialRuleReqList.push(
                  getTaobaoItemListSku({
                    current: 1,
                    size: item.skuIds.length,
                    skuIds: item.skuIds,
                    venderId: item.venderId,
                  }),
                )
              })
              Promise.all(formalRuleReqList).then((trialRes) => {
                // this.productList = trialRes.data.records;
                // 用于试用商品选择组件的回显
                // this.selectGoodsFilterArrOne = this.productList;
                // this.productListOne = formalRes.data.records;
                // 用于正装商品选择组件的回显
                // this.selectGoodsFilterArrTwo = this.productListOne;
                // this.ruleForm.trialRule.sellerSkuList[]
                if(trialRes.length>0) {
                  trialRes.forEach((item,index) => {
                    this.ruleForm.formalRule.sellerSkuList[index].itemList = item.data.records;
                  })
                }

              });
              Promise.all(trialRuleReqList).then((formalRes) => {
                if(formalRes.length>0) {
                  formalRes.forEach((item,index) => {
                    this.ruleForm.trialRule.sellerSkuList[index].itemList = item.data.records;
                  })
                }
              });
              // 活动也设置回显
              if(res.data.ruleDto.customerPaperwork){
                this.customerPaperwork = JSON.parse(res.data.ruleDto.customerPaperwork)
              } else {
                this.customerPaperwork = {
                  title: "",
                  desc: "",
                  titleColor:'#1a1a1a',
                  firstTitle: "下单试用装，领试用奖励",
                  secondTitle: "回购正装，加赠回购好礼"
                }
              }

              // 曝光商品
              this.ruleForm.exposureSwitch = isExposureItem ? true : false;
              if (this.ruleForm.exposureSwitch) {
                this.itemListForFilter = res.data.itemList;
                this.mainImagelist = res.data.itemList;
                this.selectGoodsFilterArr = res.data.itemList;
              }
              this.multiShopSkuType = multiShopSkuType || 0;
              this.skuBelongVenderId = skuBelongVenderId ||"";

              // 分享设置回显
              this.ruleForm.shareTitle = shareTitle;
              this.ruleForm.shareIntroduce = shareIntroduce;
              this.ruleForm.sharePic = sharePic;
              //商品
              this.prizeSettingList = [];
              this.prizeSettingListOne = [];
              if (pointActivityPrizeDTOList) {
                let hasTaskIndex0 = false;
                let hasTaskIndex1 = false;
                // 统一处理奖品地址限制回显：逗号分隔字符串转数字数组
                pointActivityPrizeDTOList.forEach((item) => {
                  if (item.prizeType == 3) {
                    if (item.commitAddressLimit) {
                      item.commitAddressLimit = typeof item.commitAddressLimit === 'string'
                        ? item.commitAddressLimit.split(',').map(Number)
                        : item.commitAddressLimit;
                    } else {
                      item.commitAddressLimit = [0];
                    }
                  }
                  // return item;
                });
                pointActivityPrizeDTOList.forEach((item) => {
                  if (item.taskIndex == 0) {
                    this.prizeSettingList.push(item);
                    hasTaskIndex0 = true;
                  } else {
                    this.prizeSettingListOne.push(item);
                    hasTaskIndex1 = true;
                  }
                });
                // 如果没有taskIndex==0的数据，设置试用礼默认值
                if (!hasTaskIndex0) {
                  this.prizeSettingList = [
                    //试用礼
                    // 奖项设置
                    {
                      index: 0,
                      prizeType: null,
                      price: null,
                      logo: null,
                      title: "",
                      totalAmount: null,
                      taskIndex: 0,
                    },
                  ];
                }
                // 如果没有taskIndex==1的数据，设置正装礼默认值
                if (!hasTaskIndex1) {
                  this.prizeSettingListOne = [
                    //正装礼
                    // 奖项设置
                    {
                      index: 0,
                      prizeType: null,
                      price: null,
                      logo: null,
                      title: "",
                      totalAmount: null,
                      taskIndex: 1,
                    },
                  ];
                }
              } else {
                // 如果 pointActivityPrizeDTOList不存在则给prizeSettingList和 prizeSettingListOne设置默认值
                this.prizeSettingList = [
                  //试用礼
                  // 奖项设置
                  {
                    index: 0,
                    prizeType: null,
                    price: null,
                    logo: null,
                    title: "",
                    totalAmount: null,
                    taskIndex: 0,
                  },
                ];
                this.prizeSettingListOne = [
                  //正装礼
                  // 奖项设置
                  {
                    index: 0,
                    prizeType: null,
                    price: null,
                    logo: null,
                    title: "",
                    totalAmount: null,
                    taskIndex: 1,
                  },
                ];
              }
              // 设置奖项回显
              if(pointActivityPrizeDTOList.length>1) {
                this.ruleForm.trialRule.setAwards = ruleDto.trialRule.setAwards || 1
              }
              //复制
              if (!this.activityData.isCopy) {
                // 活动时间
                this.ruleForm.startTime = startTime;
                this.ruleForm.endTime = endTime;
                this.ruleForm.ruleDescription = ruleDescription;
              }
              this.activityTimeChange();
            } catch (e) {
              console.log(e);
            }
          })
          .catch((res) => {});
      }
    },
    // 初始化时间
    setTime() {
      this.ruleForm.startTime = this.$getDate(30)[0];
      // 判断当前时间是否大于软件有效期
      const endTime = this.$getDate(30)[1];
      const endTimeValue = new Date(endTime).valueOf();
      const expiresIn = this.$store.getters.loginUserInfo.expiresIn;
      let expiresInValue = new Date(expiresIn).valueOf();
      if (endTimeValue > expiresInValue) {
        this.ruleForm.endTime = expiresIn;
      } else {
        this.ruleForm.endTime = endTime;
      }
    },
    //清空时间
    clearTime() {
      this.ruleForm.startTime = "";
      this.ruleForm.endTime = "";
      // 锁权开始时间
      this.ruleForm.lockStartTime = null;
      // 兑奖时间
      this.ruleForm.prizeEndTime = null;
    },
    //正装礼下单时间情况
    cleaerLockTimeTrial() {
      this.ruleForm.formalRule.orderStartTime = null;
      this.ruleForm.formalRule.orderEndTime = null;
    },
    //试装礼
    cleaerLockTimeTrials() {
      this.ruleForm.trialRule.orderStartTime = null;
      this.ruleForm.trialRule.orderEndTime = null;
    },
    // 清空锁权结束时间
    cleaerLockTime() {
      this.ruleForm.endTimeProducts = null;
      this.ruleForm.startTimeProducts = null;
    },
    // 清空兑奖开始时间
    cleaerPrizeTime() {
      this.ruleForm.prizeStartTime = null;
    },
    // 清空下单时间
    clearOrderTime() {
      this.ruleForm.orderStartTime = null;
      this.ruleForm.orderEndTime = null;
    },
    // 活动时间改变
    activityTimeChange() {
      // 锁权开始时间
      this.ruleForm.lockStartTime = this.ruleForm.startTime;
      // 兑奖时间
      this.ruleForm.prizeEndTime = this.ruleForm.endTime;
      // 校验有无时间
      if (!this.ruleForm.startTime || !this.ruleForm.endTime) return;
      let nowTime = new Date().getTime();
      let start = new Date(this.ruleForm.startTime).valueOf();
      let end = new Date(this.ruleForm.endTime).valueOf();
      let CRMtime = new Date(this.jdCrm.endTime).valueOf();
      // 店铺接入有效期
      let platformInvalidateDate =
        this.$store.getters.loginUserInfo.platformInvalidateDate;
      // 店铺接入有效期
      if (this.softType == 1) { // 京获客旗舰版
        platformInvalidateDate = this.$store.getters.loginUserInfo.invalidateDate;
      }
      const hdInvalidateDate =
        this.$store.getters.loginUserInfo.hdInvalidateDate;
      let platformInvalidateDateValue = new Date(
        platformInvalidateDate
      ).valueOf();
      // 互动数据授权
      let hdInvalidateDateValue = new Date(hdInvalidateDate).valueOf();
      var date3;
      const platformInvalidateDateStr = platformInvalidateDate
        ? platformInvalidateDate.split(" ")[0]
        : "";
      const hdInvalidateDateStr = hdInvalidateDate
        ? hdInvalidateDate.split(" ")[0]
        : "";
      if (this.ruleForm.endTime && this.ruleForm.startTime) {
        // 更换组件后需要更换时间计算方法
        this.timeDay = Math.floor(
          Math.abs(
            new Date(this.ruleForm.endTime) - new Date(this.ruleForm.startTime)
          ) /
            1000 /
            60 /
            60 /
            24
        );

        //计算小时
        date3 =
          new Date(this.ruleForm.endTime).getTime() -
          new Date(this.ruleForm.startTime).getTime();
        var leave1 = date3 % (24 * 3600 * 1000);
        this.timeOut = Math.floor(leave1 / (3600 * 1000));
      } else {
        this.timeOut = 0;
      }

      if (this.backgroundOpacity) return;
      if (end < nowTime) {
        this.$message.warning("活动结束时间不能小于当前时间！");
      }
      if (end < start) {
        this.$message.warning("活动开始时间不能大于结束时间！");
        return;
      }
      if (end > CRMtime && this.venderType && CRMtime && end) {
        this.$message.warning("活动有效期不可超过【云短信CRM】订购有效期。");
        this.ruleForm.endTime = "";
        return;
      }
      if (end > platformInvalidateDateValue) {
        this.$message.warning(
          `活动时间不可超过店铺接入有效期${platformInvalidateDateStr}，请重新设置！`
        );
        this.ruleForm.endTime = "";
        this.timeDay = 0;
        this.timeOut = 0;
        return;
      }
      if (end > hdInvalidateDateValue) {
        this.$message.warning(
          `活动时间不可超过互动数据授权有效期${hdInvalidateDateStr}，请重新设置！`
        );
        this.ruleForm.endTime = "";
        this.timeDay = 0;
        this.timeOut = 0;
        return;
      }
    },
    //添加指定商品弹窗
    exposureProducts() {
      this.selectGoodsState = true;
      if (this.selectGoodsArr.length == 0) {
        this.selectGoodsArr = [];
        this.selectGoodsArr = [];
      }
      if (this.ruleForm.filterType == 1) {
        this.selectGoodsArr = this.includeArr;
      } else if (this.ruleForm.filterType == 2) {
        this.selectGoodsArr = this.excludeArr;
      }
      this.$nextTick(() => {
        this.$refs.selectGo.handleRightCurrentChange(1);
      });
    },

    selectGoodsClose(data) {
      if (data) {
        let selectGoodsArr = [];
        data.forEach((value, index) => {
          let fomeVaule = {};
          fomeVaule.skuId = data[index].skuId;
          fomeVaule.logo = data[index].logo;
          fomeVaule.price = data[index].jdPrice || data[index].price;
          fomeVaule.title = data[index].wareTitle || data[index].title;
          selectGoodsArr.push(fomeVaule);
        });
        if (this.ruleForm.filterType == 1) {
          this.includeArr = selectGoodsArr;
        } else if (this.ruleForm.filterType == 2) {
          this.excludeArr = selectGoodsArr;
        }
        this.selectGoodsArr = selectGoodsArr;
      }
      this.selectGoodsState = false;
    },
    // 是否自营
    publicOpen() {
      publicOpen().then((res) => {
        if (res.message) {
          var data1 = new Date(res.message);
          var data2 = new Date();
          this.jdCrm.endTime = res.message;
          if (data1.getTime() > data2.getTime()) {
            this.jdCrm.isCrm = true;
          } else {
            this.jdCrm.isCrm = false;
          }
        }
      });
    },
    toCreated(uitype, templateId = 0) {
      if (sessionStorage.getItem("venderType") == 0) {
        this.localStepNum = 1;
      } else {
        if (this.jdCrm.isCrm) {
          this.localStepNum = 1;
        } else {
          this.$message({
            type: "warning",
            message: "自营店铺需要搭配云短信CRM使用!请联系客服!",
          });
        }
      }
      if (templateId) {
        this.templateId = templateId;
      }
      this.templateJson.templateUItype = uitype;
      // 新增活动-初始化活动时间
      if (!this.valueRow && this.isFirstTime) {
        this.isFirstTime = false;
        this.setTime();
        this.activityTimeChange();
      }
    },
    toCreated1(uitype, templateId = 0) {
      this.localStepNum = 1;
      this.templateJson.templateUItype = uitype;
      if (templateId) {
        this.templateId = templateId;
      }
    },
    toCRM() {
      window.open(
        "https://fw.jd.com/main/detail/FW_GOODS-1631?p=fw&t=pcsearch",
        "_blank"
      );
    },
    clickLocalStep() {
      if (this.backgroundOpacity) {
        this.$emit("returnBack");
        return;
      }
      if (!this.activityData.isCopy && this.valueRow && this.valueRow.id) {
        this.$emit("returnBack");
        return;
      }
      this.ruleForm.exposureSwitch = false;
      this.selectGoodsStateFilter = false;
      this.localStepNum = 0;
    },
    // 品牌定制弹窗
    handleOpen() {
      const href =
        "tencent://message/?uin=800152084&Site=%E5%9C%A8%E7%BA%BF%E5%AE%A2%E6%9C%8D&Menu=yes";
      window.open(href, "_self");
    },
    // 重置颜色
    resetColor() {
      this.ruleForm.textColor = defaultTextColor;
    },
    // 判断是否同一天
    isSameDay(date1, date2) {
      // 将日期转换为Date对象
      const d1 = new Date(date1);
      const d2 = new Date(date2);

      // 设置时间为午夜12点（这样可以忽略时分秒）
      d1.setHours(0, 0, 0, 0);
      d2.setHours(0, 0, 0, 0);

      // 比较年月日是否相同
      return d1.getTime() === d2.getTime();
    },
    // 获取时间
    getAllTime(date) {
      const time = new Date(date);
      let yy = time.getFullYear(); //当前年份
      let mm =
        time.getMonth() + 1 < 10
          ? "0" + (time.getMonth() + 1)
          : time.getMonth() + 1;
      let dd = time.getDate() < 10 ? "0" + time.getDate() : time.getDate(); //当前天数
      return `${yy}-${mm}-${dd} ${time.getHours()}:${time.getMinutes()}:${time.getSeconds()}`;
    },
    lockEndTimeChange() {
      if (this.ruleForm.prizeStartTime && this.ruleForm.endTime) {
        // 使用兑奖开始时间的时分秒
        const actEndTime72 =
          new Date(this.ruleForm.endTime).valueOf() - 72 * 60 * 60 * 1000;
        if (actEndTime72 > new Date(this.ruleForm.prizeStartTime).valueOf()) {
          if (
            this.isSameDay(
              this.ruleForm.lockEndTime,
              this.ruleForm.prizeStartTime
            ) &&
            new Date(this.ruleForm.lockEndTime).valueOf() >
              new Date(this.ruleForm.prizeStartTime).valueOf()
          ) {
            this.ruleForm.lockEndTime = this.ruleForm.prizeStartTime;
          }
        } else {
          if (
            this.isSameDay(this.ruleForm.lockEndTime, actEndTime72) &&
            new Date(this.ruleForm.lockEndTime).valueOf() >
              new Date(this.ruleForm.actEndTime72).valueOf()
          ) {
            this.ruleForm.lockEndTime = this.getAllTime(actEndTime72);
          }
        }
      } else if (this.ruleForm.prizeStartTime) {
        if (
          this.isSameDay(
            this.ruleForm.lockEndTime,
            this.ruleForm.prizeStartTime
          ) &&
          new Date(this.ruleForm.lockEndTime).valueOf() >
            new Date(this.ruleForm.prizeStartTime).valueOf()
        ) {
          this.ruleForm.lockEndTime = this.ruleForm.prizeStartTime;
        }
      } else if (this.ruleForm.endTime) {
        const actEndTime72 =
          new Date(this.ruleForm.endTime).valueOf() - 72 * 60 * 60 * 1000;
        if (
          this.isSameDay(this.ruleForm.lockEndTime, actEndTime72) &&
          new Date(this.ruleForm.lockEndTime).valueOf() >
            new Date(this.ruleForm.actEndTime72).valueOf()
        ) {
          this.ruleForm.lockEndTime = this.getAllTime(actEndTime72);
        }
      }
    },
    prizeStartTimeChange() {
      if (this.ruleForm.lockEndTime) {
        if (
          this.isSameDay(
            this.ruleForm.lockEndTime,
            this.ruleForm.prizeStartTime
          ) &&
          new Date(this.ruleForm.prizeStartTime).valueOf() <
            new Date(this.ruleForm.lockEndTime).valueOf()
        ) {
          this.ruleForm.prizeStartTime = this.ruleForm.lockEndTime;
        }
      }
    },
    orderStartTimeChange() {
      if (this.ruleForm.lockStartTime) {
        if (
          this.isSameDay(
            this.ruleForm.lockStartTime,
            this.ruleForm.orderStartTime
          ) &&
          new Date(this.ruleForm.orderStartTime).valueOf() <
            new Date(this.ruleForm.lockStartTime).valueOf()
        ) {
          this.ruleForm.orderStartTime = this.ruleForm.lockStartTime;
        }
      }
    },
    orderEndTimeChange() {
      if (this.ruleForm.endTime) {
        if (
          this.isSameDay(this.ruleForm.endTime, this.ruleForm.orderEndTime) &&
          new Date(this.ruleForm.orderEndTime).valueOf() >
            new Date(this.ruleForm.endTime).valueOf()
        ) {
          this.ruleForm.orderEndTime = this.ruleForm.endTime;
        }
      }
    },
    // 试用礼商品下单开始时间变化处理
    handleTrialOrderStartTimeChange(value) {},

    // 试用礼商品下单结束时间变化处理
    handleTrialOrderEndTimeChange(value) {
      if (!value || !this.ruleForm.endTime) return;
      const selectedDate = new Date(value);
      const activityEndDate = new Date(this.ruleForm.endTime);
      // 判断选择的日期是否与活动结束时间是同一天
      if (this.isSameDay(selectedDate, activityEndDate)) {
        this.ruleForm.trialRule.orderEndTime = this.ruleForm.endTime;
      }
    },
    // 正装礼商品下单开始时间变化处理
    handleFormalOrderStartTimeChange(value) {
      if (!value) return;
      // 如果选择的是试用礼开始时间的同一天，则设置为试用礼的开始时间
      if (this.ruleForm.trialRule.orderStartTime) {
        const selectedDate = new Date(value);
        const trialStartDate = new Date(this.ruleForm.trialRule.orderStartTime);
        if (this.isSameDay(selectedDate, trialStartDate)) {
          this.ruleForm.formalRule.orderStartTime =
            this.ruleForm.trialRule.orderStartTime;
          return;
        }
      }
    },
    // 正装礼商品下单结束时间变化处理
    handleFormalOrderEndTimeChange(value) {
      if (!value) return;
      // 如果选择的是活动结束时间的同一天，则设置为活动的结束时间
      if (this.ruleForm.endTime) {
        const selectedDate = new Date(value);
        const activityEndDate = new Date(this.ruleForm.endTime);
        if (this.isSameDay(selectedDate, activityEndDate)) {
          this.ruleForm.formalRule.orderEndTime = this.ruleForm.endTime;
          return;
        }
      }
    },
    // 检查正装商品和试用是否存在商品重合（按店铺维度：同一店铺下试用与正装商品 skuId 不可重合）
    checkSameProduct() {
      let flag = false;
      const trialSellerSkuList = JSON.parse(JSON.stringify(this.ruleForm.trialRule.sellerSkuList || []));
      const formalSellerSkuList = JSON.parse(JSON.stringify(this.ruleForm.formalRule.sellerSkuList || []));
      trialSellerSkuList.forEach((item)=>{
        item.skuIds = item.skuIds.map((item)=>(item+''))
      })
      formalSellerSkuList.forEach((item)=>{
        item.skuIds = item.skuIds.map((item)=>(item+''))
      })
      const venderIdSet = new Set();
      trialSellerSkuList.forEach((item) => {
        if (item.venderId != null) venderIdSet.add(item.venderId);
      });
      formalSellerSkuList.forEach((item) => {
        if (item.venderId != null) venderIdSet.add(item.venderId);
      });
      for (const venderId of venderIdSet) {
        const trialSkuIds =
          (
            trialSellerSkuList.find((item) => item.venderId == venderId) || {}
          ).skuIds || [];
        const formalSkuIds =
          (
            formalSellerSkuList.find((item) => item.venderId == venderId) ||
            {}
          ).skuIds || [];
        const duplicateSkuIds = trialSkuIds.filter((skuId) =>
          formalSkuIds.includes(skuId)
        );
        if (duplicateSkuIds.length > 0) {
          flag = true;
          break;
        }
      }
      if (flag) {
        this.$message.warning(
          "试用商品当前店铺的商品不可与正装商品当前店铺的商品重合"
        );
      }
      return flag;
    },
  },
};
</script>

<style lang="scss" scoped>
:deep(.titleBox){
  margin: 16px 0;
}

.rule_box {
  width: 860px;
  background: #fafafa;
  padding-bottom: 10px;
  border-radius: 4px;
  font-size: 14px;
  &_top {
    margin: 15px 0 10px 15px;
  }
  &_middle {
    margin-left: 10px;
    .middle-box {
      display: flex;
      align-items: center;
      &_tip {
        color: #ff0000;
      }
    }
  }
  &_bottom {
    margin-left: 7px;
  }
}
.createPlayStep {
  min-width: 1046px;
  position: relative;
  box-sizing: border-box;
  height: 100%;
  background-color: #fff;
  border-radius: 6px;
  .firststep {
    min-height: 720px;
    box-sizing: border-box;
    padding: 0px 35px 0;
    .itemList {
      display: flex;
      .item {
        box-sizing: border-box;
        position: relative;
        color: #666;
        text-align: center;
        padding: 6px;
        &:hover {
          .border::before,
          .border::after {
            opacity: 1;
            transform: scale(1);
          }
        }
        .border {
          position: absolute;
          left: 0;
          top: 0;
          width: 100%;
          height: 100%;
          border-radius: 4px;
          &::before,
          &::after {
            position: absolute;
            top: 0;
            right: 0;
            bottom: 0;
            left: 0;
            content: "";
            opacity: 0;
            pointer-events: none;
            transition: opacity 0.8s, transform 0.8s;
            border-radius: 4px;
          }
          &::before {
            border-top: 1px solid #fe4d45;
            border-bottom: 1px solid #fe4d45;
            -webkit-transform: scale(0, 1);
            transform: scale(0, 1);
          }
          &::after {
            border-right: 1px solid #fe4d45;
            border-left: 1px solid #fe4d45;
            -webkit-transform: scale(1, 0);
            transform: scale(1, 0);
          }
        }
        .wrapper {
          position: relative;
          height: 350px;
          border-radius: 6px;
          overflow: hidden;
          &:hover {
            .mask {
              opacity: 1;
            }
          }
          .mask {
            display: flex;
            flex-direction: column;
            justify-content: center;
            position: absolute;
            left: 0;
            top: 0;
            right: 0;
            bottom: 0;
            background-color: rgba(0, 0, 0, 0.6);
            color: #fff;
            opacity: 0;
            transition: all 0.2s;
            .img {
              max-width: 130px;
              margin: 0 auto 30px;
              .imgBg {
                box-sizing: border-box;
                height: 129px;
                width: 129px;
                padding: 6px;
                border-radius: 6px;
                background-color: #fff;
              }
              .tpl {
                display: inline-block;
                margin-top: 4px;
                opacity: 0.7;
              }
            }
          }
        }
      }
    }
  }
  .secondstep {
    box-sizing: border-box;
    position: relative;
    padding: 0px 28px 1px 24px;
    margin-bottom: 29px;
    .zd {
      width: 360px;
    }
    .time2 {
      width: 54px;
      height: 28px;
      border-radius: 4px;
      display: inline-block;
      text-align: center;
      line-height: 28px;
    }
    .lastTime {
      margin-left: 20px;
      font-size: 14px;
      i {
        color: #ccc;
      }
    }
    .limit {
      display: flex;
      flex-direction: column;
      p {
        margin: 0;
        &:nth-child(2) {
          margin: 16px 0;
        }
      }
      .c {
        color: #fe4d45;
      }
      .desc {
        i {
          opacity: 0.7;
          color: #fe4d45;
        }
        color: #999;
      }
      /deep/ .el-input {
        margin: 0 6px;
      }
    }
    .img {
      display: inline-block;
      width: 40px;
      height: 40px;
      border-radius: 50%;
      background-color: #eeeeee;
    }
    .tips {
      display: flex;
      flex-direction: column;
      margin-top: 16px;
      box-sizing: border-box;
      padding: 13px 30px;
      background: #fffaee;
      font-size: 13px;
      color: #333;
      i {
        color: #fe8f8a;
        opacity: 0.7;
      }
      p {
        margin: 0;
        line-height: 20px;
        padding-left: 18px;
      }
    }
    .generate {
      width: 76px;
      margin-top: 8px;
      background: rgba(254, 77, 69, 0.1);
      border: 1px solid rgba(254, 77, 69, 1);
      color: #fe4d45;
    }
    .termAdd {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 6px;
      color: #333;
      p {
        margin: 0;
      }
      .add {
        margin-left: 4px;
        color: #fe4d45;
      }
    }
    .set {
      display: inline-block;
      margin-top: 30px;
    }
    .desc {
      margin-left: 20px;
      color: #999;
      font-size: 13px;
      i {
        color: #fe8f8a;
        opacity: 0.7;
        font-size: 13px;
      }
    }
    .s {
      color: #2768ff;
      cursor: pointer;
    }
    .rule-tip {
      margin-top: 8px;
    }
    .act-tip {
      white-space: nowrap;
      color: #ff0000;
    }
    /deep/ .el-table .el-table__header-wrapper th {
      border-right: 1px solid #f0f0f0;
      &:last-child {
        border-right: none;
      }
    }
    /deep/ .el-table--enable-row-transition .el-table__body td {
      text-align: center;
      border-right: 1px solid #f0f0f0;
      &:last-child {
        border-right: none;
      }
    }
  }
}
.miniAppPic {
  position: relative;
  .image-slot {
    width: 100%;
    height: 100%;
    background: #f5f7fa;
    text-align: center;
    padding-top: 43px;
    i {
      font-size: 30px;
      color: #909399;
    }
  }
  .top {
    position: relative;
    left: 8px;
    display: flex;
    .returnBtn {
      border-radius: 4px;
      width: auto;
      height: 32px;
      line-height: 32px;
      text-align: center;
      color: #fe4d45;
      background: rgba(254, 77, 69, 0.1);
      border: 1px solid #fe4d45;
      &:hover {
        color: #fff;
        background: #fe4d45;
      }
    }
    .reset {
      color: #fe4d45;
      cursor: pointer;
      font-size: 14px;
      margin-left: 15px;
    }
  }
  .bottom {
    position: relative;
    top: 15px;
    margin-left: 115px;
    .elImg {
      width: 120px;
      height: 120px;
      border: 1px dashed #dddddd;
      border-radius: 5px;
    }
    .tips1 {
      position: absolute;
      left: 135px;
      top: 22px;
      line-height: 2;
      color: #aaaaaa;
      font-size: 13px;
    }
  }
  .support {
    display: flex;
    align-items: center;
    &-text {
      margin: 0px 8px;
    }
    &-icon {
      color: #ccc;
      cursor: pointer;
    }
  }
}

.input-w425 {
  width: 425px;
}

.label {
  &-right {
    margin-right: 8px;
  }
  &-left {
    margin-left: 8px;
  }
}

.el-icon-question {
  color: #ccc;
  cursor: pointer;
}

.flex-center {
  display: flex;
  align-items: center;
}

.el-textarea {
  /deep/ .el-input__count {
    padding: 0px 5px;
    line-height: normal;
  }
}
</style>
<style lang="scss" scoped>
.createPlayStep {
  .textarea {
    .el-textarea__inner {
      min-height: 120px !important;
    }
  }
  .el-step__main {
    position: absolute;
    top: -7px;
    left: 33px;
  }
  .el-step__head.is-process {
    position: absolute;
  }
  .el-step.is-horizontal .el-step__line {
    left: 107px;
    right: 15px;
  }
  .el-step {
    position: relative;
  }
}
.prize-list-container {
  padding: 20px;
}

.prize-section h3 {
  margin-bottom: 15px;
  font-size: 16px;
  font-weight: bold;
}

.info-tip {
  background: #e6f7ff;
  border: 1px solid #91d5ff;
  border-radius: 4px;
  padding: 8px 12px;
  margin-bottom: 20px;
  color: #1890ff;
}

.info-tip i {
  margin-right: 5px;
}

.time-setting {
  margin-bottom: 15px;
  display: flex;
  align-items: center;
}

.time-setting label {
  margin-right: 10px;
  font-weight: bold;
}

.note {
  font-size: 14px;
  margin-bottom: 20px;
  line-height: 1.5;
  margin-left: 137px;
  color: red;
}

.tip-color {
  font-size: 14px;
  line-height: 1.5;
  color: red;
}

.product-section {
  margin-bottom: 30px;
  margin-left: 140px;
}

.product-section label {
  font-weight: bold;
  margin-right: 10px;
}

.product-image-cell {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 60px;
}

.product-thumb {
  width: 50px;
  height: 50px;
  object-fit: cover;
  border-radius: 4px;
}

.product-placeholder {
  width: 50px;
  height: 50px;
  background: #f5f5f5;
  border: 1px dashed #d9d9d9;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  color: #999;
  border-radius: 4px;
}

.prize-list-section h4 {
  margin-bottom: 15px;
  font-size: 14px;
  font-weight: bold;
}

/* 图片上传对话框样式 */
.image-upload-container {
  text-align: center;
}

.current-image {
  margin-bottom: 20px;
}

.preview-image {
  width: 200px;
  height: 200px;
  object-fit: cover;
  border-radius: 8px;
  border: 1px solid #d9d9d9;
}

.image-actions {
  margin-top: 10px;
}

.image-uploader {
  display: inline-block;
}

.upload-placeholder {
  width: 200px;
  height: 200px;
  border: 2px dashed #d9d9d9;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: border-color 0.3s;
}

.upload-placeholder:hover {
  border-color: #409eff;
}

.upload-placeholder i {
  font-size: 28px;
  color: #c0c4cc;
  margin-bottom: 10px;
}

.upload-text {
  color: #606266;
  font-size: 14px;
}

.upload-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 200px;
  height: 200px;
  background: rgba(0, 0, 0, 0.6);
  color: white;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  cursor: pointer;
  opacity: 0;
  transition: opacity 0.3s;
}

.upload-overlay:hover {
  opacity: 1;
}

.upload-overlay i {
  font-size: 20px;
  margin-bottom: 5px;
}

.upload-tips {
  margin-top: 15px;
  color: #999;
  font-size: 12px;
}

.dialog-footer {
  text-align: right;
}

.m-l--50 {
  margin-left: -50px;
}

.mtb16 {
  margin: 16px 0;
}
</style>
